(function($) {
  if ($("#filter-sidebar")) {
    History.Adapter.bind(window, "statechange", function() {
      var e = History.getState();
      if (!mt._sidebarAjaxClick) {
        mt._sidebarparams();
        var n = mt._sidebarcreateUrl();
        mt._sidebargetContent(n);
        mt._reactivesidebar();
      }
      mt._sidebarAjaxClick = false
    })
  }
  if (window.use_color_swatch) {
    $(".swatch :radio").change(function() {
      var t = $(this).closest(".swatch").attr("data-option-index");
      var n = $(this).val();
      $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
    });
    Shopify.optionsMap = {};
    Shopify.updateOptionsInSelector = function(t) {
      switch (t) {
        case 0:
          var n = "root";
          var r = $(".single-option-selector:eq(0)");
          break;
        case 1:
          var n = $(".single-option-selector:eq(0)").val();
          var r = $(".single-option-selector:eq(1)");
          break;
        case 2:
          var n = $(".single-option-selector:eq(0)").val();
          n += " / " + $(".single-option-selector:eq(1)").val();
          var r = $(".single-option-selector:eq(2)")
          }
      var i = r.val();
      r.empty();
      var s = Shopify.optionsMap[n];
      
      for (var o = 0; o < s.length; o++) {
        var u = s[o];
        var a = $("<option></option>").val(u).html(u);
        r.append(a)
      }
      $('.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr("data-value"), s) !== -1) {
          $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
        } else {
          $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }
      });
      if ($.inArray(i, s) !== -1) {
        r.val(i)
      }
      r.trigger("change")
    };
    Shopify.linkOptionSelectors = function(mt) {
      for (var n = 0; n < mt.variants.length; n++) {
        var r = mt.variants[n];
        if (r.available) {
          Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
          Shopify.optionsMap["root"].push(r.option1);
          Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
          if (mt.options.length > 1) {
            var i = r.option1;
            Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
            Shopify.optionsMap[i].push(r.option2);
            Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
          }
          if (mt.options.length === 3) {
            var i = r.option1 + " / " + r.option2;
            Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
            Shopify.optionsMap[i].push(r.option3);
            Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
          }
        }
      }
      Shopify.updateOptionsInSelector(0);
      if (mt.options.length > 1) Shopify.updateOptionsInSelector(1);
      if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
      $(".single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1);
        if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true
      });
      $(".single-option-selector:eq(1)").change(function() {
        if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true
      })
    }
  }
  $(document).ready(function() {
    mt.go()
  });
  $(window).resize(function() {
    mt._resizeImage()
  });
  var mt = {
    atTimeout: null,
    _sidebarAjaxClick: false,
    go: function() {
      this._spinner();
      this._resizeImage();
      this._quickview();
      this._sidebar();
      this._zoomimage();
      this._scrollTop();
      this._headerdropcart();
      this.translateBlock(".main-content");
      this._addtocart();
      this._overcart();

      this._quickshop();
      this._mesagebox();
      this._productaddtocart();
      this._wishlist();
      this._quickviewwishlist();
      this._productwishlist();
      this._removewishlist();
      this._colorswatchgridInit();
      this._infinitescrolling();
      this._autoinfinitescrolling();
      this.free_shipping();
      this._ajaxnewsleter();
      this._contactSubject();
//       this._searchresults();
      this._snize_custom();
      this._productUpdate();
      
//       this._recently();
      // this._spinner();
      
    },
    _checkDevice : function(){
      let isDevice = false;
      var smartPhones = new Array('iPhone','iPad','SAMSUNG','BlackBerry','Android','Windows CE','Windows CE;','LG','MOT','SonyEricsson','Symbian','Opera Mobi','Opera Mini','IEmobile');
      var windowsize = $(window).width();
        for(var word in smartPhones){
          if(navigator.userAgent.match(smartPhones[word])!=null){
           isDevice = true;
          }
        }
      return isDevice;
    },
    _spinner : function(){
      $(window).on('load', function(){
        $(".loadding-collection").fadeOut("slow");
      })
    },
    _snize_custom: function(n){
      var snizeAcHasResults = true;
      $(document).on('Searchanise.DataRequestEnd', function(e, type, params, data) { 
        if (type == 'autocomplete') {
          snizeAcHasResults = data.items.length ? true : false;
        }
        
        
         function hoverProduct(){
          // setting
          var subtotal,
              title,
              $link,
              findString,
              $id,
              $inv,
              hoverdiv,
              wishdiv,
              wishBtn,
              wishIcon,
              wishDiv,
              src,
              labeldiv;

          subtotal = data.startIndex;
          findString = "https://cosa-piora-corp.myshopify.com/products/";

          var i;
          for(i=0; i< data.items.length; i++){
            title = data.items[i].title;
            $link = data.items[i].link;
            $id = data.items[i].product_id;
            $inv = data.items[i].quantity_total;
            Newcont(i,title,$link,$id,$inv);
            // console.log(data.items[i])
            // console.log(i+" // "+title+" // "+$link+" // "+$id)
          }

          function Newcont(i,title,$link,$id,$inv){
            i = i + subtotal;

            //title = mt.translateText(title);
            if($link.indexOf(findString) != -1) {
              $link = $link.replace(findString,""); 
            }

            setTimeout(function() {
              $(".snize-search-results-main-content .snize-product").eq(i).addClass("product-item");
              $(".snize-search-results-main-content .snize-product").eq(i).find(".snize-item").addClass("option_hover_product_10 option_hover_product_2");

              // title
              // $(".snize-search-results-main-content .snize-product").eq(i).find(".snize-title").html(title);

              // hover product
              hoverdiv ='<div class="hover-product-2"><div class="hover-product-inner"><div class="add-to-link"><div class="quickview-button"><a id="'+$link+'" data-inv="'+$inv+'" data-toggle="tooltip" data-placement="top" class="sca-qv-button harman_btn3 hover_icon"><span class="tooltips">Quick View</span><i class="pd_icon icon-hover-quickview"></i></a></div></div><div class="add-to-cart hover_icon"><form action="/cart/add" method="post" class="variants hover_icon" id="product-actions-'+$id+'" enctype="multipart/form-data" style="padding:0px;"><input type="hidden" name="id" value='+$id+' /><button class="add-to-cart-btn" type="submit"><span class="tooltips">BAG</span><i class="pd_icon icon-hover-cart"></i></button></form></div><div class="wishlist-wr hover_icon"><button type="button" class="wk-button-collection wk-add-product" data-wk-add-product="'+$id+'"><i class="pd_icon icon_heart icon-hover-like"></i><div class="wk-label">Wishlist</div></button></div></div></div>'
              

              // console.log(i, title, $inv)
           
              $(".snize-search-results-main-content .snize-product").eq(i).find(".snize-thumbnail").append(hoverdiv);

              mt._searchcart();
            },300);
          }

          // loading spinner
          setTimeout(function(e) {
            $(".snize-pagination").prepend('<div class="loading-product" style="position: relative; z-index: 9;display: none;"><img src="https://cdn.shopify.com/s/files/1/0213/5710/1156/t/118/assets/loading-top.gif?v=11271137452017985690" alt=""></div>');

            mt._quickview();
            mt._searchwish();
            mt._infinitescrolling();
            
            $(".snize-pagination-load-more").click(function(e) {
              e.preventDefault();
              $(".loading-product").show();
            });

            
            // product label
            labeldiv = '<div class="product-label"><span class="sale_label">SALE</span></div>';
            if($(".snize-product-label").length){
              $(".snize-product-label").parent().prepend(labeldiv);
            }

          },400);
          
          
        }
        
         hoverProduct();
        $(window).resize(hoverProduct);
       
      });

     document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
      Searchanise.$(Searchanise.SearchInput).parent('form').bind('submit.autocomplete', function(e) {
        if (!snizeAcHasResults) {
          e.stopImmediatePropagation();
          return false;
        }
      });
    })(window.Searchanise.$);
});
      $(document).on('Searchanise.AddToCartSuccess', function(e, productId, itemData) {
        mt._updateheadercart();
        jQuery('#dropdown-cart').addClass('active');
        jQuery('.wrapper-container').addClass('show-cart');
        $(".snize-add-to-cart-button.size-button-view-cart").removeClass("size-button-view-cart");
      });
    },
    _searchcart: function(){
      var btn;
      $(".add-to-cart-btn").click(function(){
        btn = $(this).parents(".snize-product").find(".snize-add-to-cart-button");
        btn.trigger("click");
        
        return false;
      })
    }, 
    _searchwish: function(e){  
      var btn,
          target,
          origin,
          id,
          src;
      $(".wishlist-wr .wk-button-collection").click(function(e){
        e.preventDefault();

        origin = $(this).parents(".snize-product").find(".wk-search");
        target = $(this).find("img");
        id = target.attr("id");
        
        // if customer
//         if(origin.hasClass("wk-remove-product")){
          if(id == 'on'){
            src = 'https://cdn.shopify.com/s/files/1/0213/5710/1156/files/hover_heart.png?v=1584959619';
            target.attr("id","off")
          }else{
            src = 'https://cdn.shopify.com/s/files/1/0213/5710/1156/files/hover_heart_on.png?v=1584959619';
            target.attr("id","on");

          }
          
          $(this).find("img").attr("src",src);
//         }

        // trigger 
        btn = $(this).parents(".snize-product").find(".wk-search");
        btn.trigger("click");
        
        
      })
    },
    _contactSubject: function(n){
      $("#ContactFormSubject").change(function() {
        if ($(this).data('options') === undefined) {
          /*Taking an array of all options-2 and kind of embedding it on the select1*/
          $(this).data('options', $('#ContactFormSubjectDetail option').clone());
        }
        $(this).removeClass("margin empty").addClass("fill");
        $("#contactFormOrderNum").removeClass("margin");
        
        var id = $(this).val();
        var options = $(this).data('options').filter('[value=' + id + ']');
        $('#ContactFormSubjectDetail').html(options).removeAttr("disabled").removeClass("beforeOne empty");
         $("<option disabled selected value>Select subject detail *</option>").prependTo($("#ContactFormSubjectDetail"));
      });
      
      $("#ContactFormSubjectDetail").change(function() {
         $(this).removeClass("empty").addClass("fill");
      })
      
      if (window.matchMedia("(max-width: 767px)").matches){
        $("#ContactFormSubjectDetail").insertBefore("#contactFormOrderNum")
      }
      
      
    },
    _productUpdate: function(){
      if(($("body").hasClass("template-collection"))||($("body").hasClass("snize-results-page"))){

        var data = {};
        $.ajax({
          type: "get",
          dataType: 'json',
          url: "/products.json?limit=250&page=1",
          data: data,
          success: function(data){
          
            var i = data.products.length;
            for(var i in data.products){
     
              var update = new Date(data.products[i].created_at).getTime();
              var now = new Date().getTime();
              var distance = new Date(now - update) ;
              var days = Math.floor((now - update) / (1000 * 60 * 60 * 24));
              var ddd = new Date(data.products[i].created_at)
              if (days < 7) {
                $(".productUpdate#product-"+data.products[i].id).addClass("newin-product");
                console.log(data.products[i].title, "//", days, ddd)
//                   console.log(data.products[i])
                //console.log(days)
              }
              
            }

          },
          error: function(){
            console.log("error");
          }
        }); 
      }
    },

    _ajaxnewsleter: function() {
      function t(t, e, o) {
       $.ajax({
          type: "GET",
          url: t.attr("action"),
          data: t.serialize(),
          cache: !1,
          dataType: "jsonp",
          jsonp: "c",
          contentType: "application/json; charset=utf-8",
          error: function(t) {
            var a = t.replace("0 - ", "").replace("1 - ", "").replace("2 - ", "");
            e.html('<div class="message-error">' + a + "</div>").show(100)
          },
          success: function(t) {
            var a = t.msg.replace("0 - ", "").replace("1 - ", "").replace("2 - ", "");
        
            "success" != t.result ? e.html('<div class="message-warning">' + a + "</div>").show(100) : e.html('<div class="message-susscer">' + a + "</div>").show(100)
          }
        })
      }
      $('form.clv-ajax-from [type="submit"]').bind("click", function(e) {
        var o = $(this).closest("form.clv-ajax-from"),
            a = o.find(".message-newsneter"),
            s = $(this);
        e && e.preventDefault(), a.hide(100), t(o, a, s)
      })
    },
    _autoinfinitescrolling: function() {

      var itemsWrapper = '.collection-grid';
      var count = $('.collection-product-item').length;
     
      var count_item = $('.infinite-scrolling').attr('data-count');
   
      if(count_item > count){


        //Scrolling loading example
        var scrollingLoadingOptions = {
          selectors              : {
            itemsWrapper     : itemsWrapper,
            item             : '.collection-product-item',
            nextPageLink     : '#paginatie-next',
            previousPageLink : '#paginatie-previous',
            paginationWrapper: '.component-pagination',
            //scrollableElem: itemsWrapper, YOU CAN SPECIFY THIS
//             scrollableElem: null,
          },

          waitForImagesToBeLoaded: false,
          //throttleDelay: 100, YOU CAN SPECIFY THIS
//           pageQueryStringKey: 'page',
//           waitForImagesToBeLoaded: false,
//           enablePageState: true,
//           manualLoading: true,
          
          callBacks              : {
            onAllPagesLoaded: function () { 
              $('.component-pagination').css("display", "none");
              $('.loading-more').text("All products loaded.").addClass('active');
              $('.loading-more').show();
            },
            beforePageLoad  : function () {
              $('.loading-more').show();
              //console.log("Before page load callback called..");
            },
            onPageLoad      : function (items) {
              $('.loading-more').hide();
              if (window.product_image_resize) {
                $(".products-grid .product-image img").fakecrop({
                  fill: window.images_size.is_crop,
                  widthSelector: ".products-grid .grid-item .product-image",
                  ratioWrapper: window.images_size
                })
              }     
              //console.log("Page loaded callback called..");
            }
          }
        };
        $(itemsWrapper).t3PageLoad(scrollingLoadingOptions);
      };
      
    },
    _checkLoadmoreBtn2: function(){
//       var waitForEl = function(selector, callback) {
//         if (jQuery(selector).length) {
//           $(".template-collection .main-content").removeClass("nomore");
//           callback();
//         } else {
//           setTimeout(function() {
//             $(".template-collection .main-content").addClass("nomore");
//             waitForEl(selector, callback);
//           }, 100);
//         }
//       };

//       waitForEl("#gsloadmore", function() {
//         mt._infinitescrolling();
//       });
    },
   
    _infinitescrolling: function() { 
      if($("#gsloadmore").length){
        var clickcount,
            i,
            element,
            bodyId;

        var windowsize = $(window).width();
        if(windowsize > 767){
          bodyId = $("body").attr("id");
          element = $(".product-grid-item .product-items").length;

          if(element <= 14){ 
            clickcount = 0;
          }else if(element <= 30){
            clickcount = 1;
          }else if(element <= 44){
            clickcount = 2;
          }else if(element <= 60){
            clickcount = 3;
          }else if(element <= 76){
            clickcount = 4;
          }else if(element <= 90){
            clickcount = 5;
          }else if(element <= 106){
            clickcount = 6;
          }else if(element <= 122){
            clickcount = 7;
          }else{
            clickcount = 7;
          }
          setTimeout(function(){
            for(i = 1 ; i<=clickcount; i++ ){ 
              mt._rdimgLoad(i, bodyId)
            }
          },500);

          // click loadmore btn
          $("#gsloadmore").click(function(n) {
            clickcount += 1;
            mt._loadmoreActive(clickcount, bodyId);
          });
        }
      }
    },
    _loadmoreActive: function(clickcount, bodyId){
      var colpd = $(".product-grid-isotope-parent").attr("id");
      var pdlength;
      switch (clickcount) {
        case 1:
          if(colpd < 30){
            if(colpd > 24){
              pdlength = 24;
            }else{
            pdlength = colpd;
              }
          }else{
            pdlength = 30;
          }
          clickcount = 1;
          break;
        case 2:
           if(colpd < 44){
             pdlength = colpd;
           }else{
             pdlength = 44;
             }
          clickcount = 2;
          break;
        case 3:
          if(colpd < 60){
           pdlength = colpd;
         }else{
           pdlength = 60;
           }
          clickcount = 3;
          break;
        case 4:
         if(colpd < 76){
           pdlength = colpd;
         }else{
           pdlength = 76;
           }
          clickcount = 4;
          break;
        case 5:
          if(bodyId == "cosa-piora"){
            pdlength = 83;
          }else{
            pdlength = 90;
          }
          clickcount = 5;
          break;
        case 6:
          pdlength = 106;
          clickcount = 6;
          break;
        case 7:
          pdlength = 117;
          clickcount = 7;
          break;  
      }
      
      // roof original function
      var waitForPd = function(selector, pdlength, callback){

         
        var wait =  setTimeout(function() {
          // console.log('pdlength = ', $(selector).length)
        },3000)
        // console.log($(selector).length, pdlength)
        
        if($(selector).length >= pdlength){
          $(".loading-product").hide();
          callback();
        }else{
          var sett = setTimeout(function() {
            waitForPd(selector, pdlength, callback)
          },100);


          
          
        //   if($(selector).length <=30){
        //   pdlength = $(selector).length;
        // }
        }
      }
      
      
      // set 
      waitForPd(".product-grid-item .product-items", pdlength ,function(){
        // console.log(clickcount +" // "+ bodyId+ " // " + $(".product-grid-item .product-items").length)
        
        mt._addtocart();
        mt._quickview();
        
        // loadmore random img
        mt._rdimgLoad(clickcount, bodyId);
        mt._productUpdate();
      })
    },
    
    _infinitescrolling2: function() { 
      if ($(".infinite-scrolling").length > 0) {
        var clickcount = 0;
        $(".loading-product").hide();
        $(".infinite-scrolling a").click(function(n) {
          clickcount += 1;
          n.preventDefault();
          if (!$(this).hasClass("disabled")) {
            mt.doInfiniteScrolling(clickcount)
          }
        })
      }
    },

    doInfiniteScrolling: function(clickcount) {
      var n = $(".main_container .products-grid");

      if (!n.length) {
        n = $(".main_container .product-list")
      }
      if (n) {
        var r = $(".infinite-scrolling a").first();
        $.ajax({
          type: "GET",
          url: r.attr("href"),
          beforeSend: function() {
            $(".loading-product").show();
          },
          success: function(i) {
            mt.hideLoading();
            $(".loading-product").hide();
            var s = $(i).find(".main_container .products-grid");
            if (!s.length) {
              s = $(i).find(".main_container .product-list-item")
            }
            if (s.length) {
              if (s.hasClass("products-grid")) {
                if (window.product_image_resize) {
                  s.children().find("img").fakecrop({
                    fill: window.images_size.is_crop,
                    widthSelector: ".products-grid .grid-item .product-image",
                    ratioWrapper: window.images_size
                  })
                }
              }
              n.append(s.children());
              mt._quickview();
              mt._addtocart();
              mt._wishlist();
              
              if ($(i).find(".infinite-scrolling").length > 0) {
                r.attr("href", $(i).find(".infinite-scrolling a").attr("href"))
              } else {
                r.hide();
                r.next().show()
              }
              if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
              }
            }
            
            
            if($(".collection-page .infinite-scrolling a").css('display') == 'none'){
              $(".main-content").css("min-height","auto");
              $(".template-collection .main-content").css({
                "padding-bottom":"0px",
                "margin-bottom":"-1px"
              });
            }else{
              $(".template-collection .main-content").css({"padding-bottom":"30px"});
            }
            
            // loadmore random img
//             mt._rdimgLoad(clickcount);
            mt._pdlistGrid();
            mt._productUpdate();
           
            
          },
          error: function(n, r) {
            mt.hideLoading();
            $(".loading-product").hide();
            $(".ajax-error-message").text($.parseJSON(n.responseText).description);
            mt.showModal(".ajax-error-modal")
          },
          dataType: "html"
        })
      }
    },
    _colorswatchgridInit: function(){
      $('.color-swatch-item li a').click(function(e){
        e.preventDefault();  
        var productImage = $(this).parents('.product-inner').find('.grid-image'); 
        productImage.find('img.feature-images').attr('src', $(this).data('image'));  
      });
    },
    _ajaxsidebar: function() {
      $(".sidebar-tag a, .sidebar-tag label").click(function(n) {
        var r = [];
        if (Shopify.queryParams.constraint) {
          r = Shopify.queryParams.constraint.split("+")
        }
        if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
          var i = $(this).parents(".sidebar-tag").find("input:checked");
          if (i.length > 0) {
            var s = i.val();
            if (s) {
              var o = r.indexOf(s);
              if (o >= 0) {
                r.splice(o, 1)
              }
            }
          }
          
        }
        var s = $(this).prev().val();
        if (s) {
          var o = r.indexOf(s);
          if (o >= 0) {
            r.splice(o, 1)
          } else {
            r.push(s)
          }
        }
        if (r.length) {
          Shopify.queryParams.constraint = r.join("+")
        } else {
          delete Shopify.queryParams.constraint
        }
        mt.sidebarAjaxClick();
        n.preventDefault()
      })
    },


    _evensidebar: function() {
      mt._ajaxsidebar();

    },

    _checkitemdropcart: function() {
      if ($("#dropdown-cart .cart-list").children().length > 0) {
        $("#dropdown-cart .cart-empty").hide();
        $("#dropdown-cart .mini_cart_header").show()
      } else {
        $("#dropdown-cart .mini_cart_header").hide();
        $("#dropdown-cart .cart-empty").show()
      }
    },

    _headerdropcart: function() {
      mt._checkitemdropcart();
      $("#dropdown-cart .cart-empty a").click(function() {
        $("#dropdown-cart").slideUp("fast")
      });
      $("#dropdown-cart .btn-remove").click(function(n) {
        n.preventDefault();
        // ITG CODE START
        var cart = $(this).closest(".item").data("key");
        // var cart = $(this).parents(".item").attr("id");
        // cart = cart.match(/\d+/g);
        // ITG CODE END
        Shopify.removeItem(cart, function(e) {
          mt._headercartitem(e);
          $(this).addClass('remove-cart');
        })
      })
    },
    closeDropdownCart: function() {
      if ($("#dropdown-cart").is(":visible")) {
        $("#dropdown-cart").slideUp("fast")
      }
    },

    _accordionsibar: function() {
      if ($(".sidebar-tag").length > 0) {
        $(".sidebar-tag .widget-title span").click(function() {
          var cart = $(this).parents(".widget-title");
          if (mt.hasClass("click")) {
            mt.removeClass("click")
          } else {
            mt.addClass("click")
          }
          $(this).parents(".sidebar-tag").find(".widget-content").slideToggle()
        })
      }
    },
    _clearsidebarall: function() {
      $('.addlabel a').each(function() {
        //         $(this).click(function() {
        //           var r = [];
        //           if (r.length) {
        //             Shopify.queryParams.constraint = r.join("+")
        //           } else {
        //             delete Shopify.queryParams.constraint;
        //             mt.sidebarAjaxClick();
        //           }
        //         })

        const filterTag = $(this);

        filterTag.click(function(e) {
          e.preventDefault();
          const tag = $(this).data('filterTag');
          let params = Shopify.queryParams.constraint.split(' ');
          params.splice(params.indexOf(tag), 1);
          Shopify.queryParams.constraint = params.join(' ');
          mt.sidebarAjaxClick();

        });
      })
      $("a.clear-all").click(function() {
        $(this).removeClass('active');
        $('body').find(".addlabel").removeClass('active');
        $('body').find(".filter-top-wr").removeClass('active-filter-top');
      });
      $("#filter-sidebar a.clear-all").click(function($) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        mt.sidebarAjaxClick();
        $.preventDefault();
      })
     


    },
    _clearsidebar: function() {
//       $(".sidebar-tag").each(function() {
        var n = $(".filter-wr .sidebar-tag");
        if (n.find("input:checked").length > 0) {
          $('.wrapper-container').removeClass('show-fillter');
//           $('body').find(".clear-all").addClass('active');

//           $('body').find(".addlabel").addClass('active');
//           $('body').find(".filter-top-wr").addClass('active-filter-top');
          n.find(".clear-all").show().click(function(cart) {
            var i = [];
            if (Shopify.queryParams.constraint) {
              i = Shopify.queryParams.constraint.split("+")
            }
            n.find("input:checked").each(function() {

              var cart = $(this);
              var n = mt.val();
              if (n) {
                var cart = i.indexOf(n);
                if (r >= 0) {
                  i.splice(cart, 1)
                }
              }
            });
            if (i.length) {
              Shopify.queryParams.constraint = i.join("+")
            } else {
              delete Shopify.queryParams.constraint
            }
            mt.sidebarAjaxClick();
            cart.preventDefault()
          })
        }else{
          $('body').find(".clear-all").removeClass('active');
          $('body').find(".addlabel").removeClass('active');
          $('body').find(".filter-top-wr").removeClass('active-filter-top');
        }
//       })
    },
    _evensidebar: function() {
      mt._ajaxsidebar();
      mt._collectionlinkajax();
      mt._colorswatchgridInit();
    },
    _reactivesidebar: function() {
      $(".sidebar-custom .active, .sidebar-links .active").removeClass("active");
      $(".sidebar-tag input:checked").attr("checked", false);

      var n = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (n && n[1]) {
        $(".sidebar-links a[href='" + n[0] + "']").addClass("active");
        $(".sidebar-tag").addClass('1111');
      }
      if (Shopify.queryParams.view) {
        $(".view-mode .active").removeClass("active");
        var cart = Shopify.queryParams.view;
        if (cart.indexOf("list") >= 0) {
          cart(".view-mode .list").addClass("active");
          cart = cart.replace("list", "")
        } else {
          $(".view-mode .grid").addClass("active")
        }
        $(".filter-show > button span").text(cart);
        $(".filter-show li.active").removeClass("active");
        $(".filter-show a[href='" + cart + "']").parent().addClass("active")
      }
    },
    _collectionlinkajax: function() {
      $(".sidebar-links a").click(function(n) {
        if (!$(this).hasClass("active")) {
          delete Shopify.queryParams.q;
          mt.sidebarAjaxClick($(this).attr("href"));
          $(".sidebar-links a.active").removeClass("active");
          $(this).addClass("active")
        }
        n.preventDefault()
      })
    },
    sidebarMapData: function(n) {
      var rs = $(".col-main .products-grids");
      if (rs.length == 0) {
        rs = $(".col-main .product-list")
      }
      var is = $(n).find(".col-main .products-grids");
      if (is.length == 0) {
        is = $(n).find(".col-main .product-list")
      }
      var cart = $(".col-main .products-grid");
      if (cart.length == 0) {
        cart = $(".col-main .product-list")
      }
      var i = $(n).find(".col-main .products-grid");
      if (i.length == 0) {
        i = $(n).find(".col-main .product-list")
      }
      if (i.length > 0 && i.hasClass("products-grid")) {
        if (window.product_image_resize) {
          i.find("img").fakecrop({
            fill: window.images_size.is_crop,
            widthSelector: ".products-grid .grid-item .product-image",
            ratioWrapper: window.images_size
          })
        }
      }
      cart.replaceWith(i);
      rs.replaceWith(is);
      if ($(".padding").length > 0) {
        $(".padding").replaceWith($(n).find(".padding"))
      } else {
        $(".main-content .col-main").append($(n).find(".padding"))
      }
      var s = $(".page-header");
      var o = $(n).find(".page-header");
      if (s.find("h2").text() != o.find("h2").text()) {
        s.find("h2").replaceWith(o.find("h2"));
        if (s.find(".rte").length) {
          if (o.find(".rte").length) {
            s.find(".rte").replaceWith(o.find(".rte"))
          } else {
            s.find(".rte").hide()
          }
        } else {
          if (o.find(".rte").length) {
            s.find("h2").after(o.find(".rte"))
          }
        }
      }
      $(".addlabel").replaceWith($(n).find(".addlabel"));
      $(".sidebar-block").replaceWith($(n).find(".sidebar-block"))
    },
    _sidebarcreateUrl: function(mt) {
      var n = $.param(Shopify.queryParams).replace(/%2B/g, "+");
      if (mt) {
        if (n != "") return mt + "?" + n;
        else return mt
          }
      return location.pathname + "?" + n
    },
    sidebarAjaxClick: function(e) {
      delete Shopify.queryParams.page;
      var n = mt._sidebarcreateUrl(e);
      mt._sidebarAjaxClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, n, n);
      mt._sidebargetContent(n)
    },

    _sidebargetContent: function(n) {
      $.ajax({
        type: "get",
        url: n,
        beforeSend: function() {
          mt.showLoading();
          $('.loadding-collection').show();
        },
        success: function(e) {
          $('.loadding-collection').hide();
          mt.sidebarMapData(e);
          mt._ajaxsidebar();
          mt._accordionsibar();
          mt._clearsidebar();
          mt._clearsidebarall();
          mt.hideLoading();
          mt._addtocart();
          mt._wishlist();
          mt._colorswatchgridInit();
          mt._quickview();
          mt._quickshop();
          mt._infinitescrolling();
          mt._infinitescrolling2();
          
          // add custom function
          mt._filterdropdown();
//           mt._rdimg();
          mt._paddingnone();
        },
        error: function(n, cart) {
          mt.hideLoading();
          $(".loading-modal").hide();
          $('.loadding-collection').hide();
          $(".ajax-error-message").text($.parseJSON(n.responseText).description);
          mt.showModal(".ajax-error-modal")
        }
      })
    },
    // add custom function
    _filterdropdown: function(){
      $("button.filter_title").click(function(){
        $(this).parent().find("div.content").slideToggle();
        $(this).toggleClass("filteractive");  
      });
    },
    _paddingnone: function(){
      if($(".collection-page .infinite-scrolling a").css('display') == 'none'){
        $(".main-content").css("min-height","auto");
        $(".template-collection .main-content").css({
          "padding-bottom":"0px",
          "margin-bottom":"-1px"
        });
      }else if(!$(".collection-page .infinite-scrolling").length){
        $(".main-content").css("min-height","auto");
        $(".template-collection .main-content").css({
          "padding-bottom":"0px",
          "margin-bottom":"-1px"
        });
      }else{
        $(".template-collection .main-content").css({"padding-bottom":"30px"});
       
      }
    },
    _rdimg: function(){
      if($(".filter-wr .sidebar-tag .content .widget-content").find("input:checked").length){
        return;
      }else{
//         function hideBefore(){$(".collection-page").addClass("show_after")}function init(){}function pdRandom(e){e=$("body").hasClass("tablet")?"z":"y",colName=$("body").attr("id"),colName.includes("cosa-")&&(colName=colName.replace("cosa-","")),"blanc"==colName&&under5(colName,e),"rispetto"!=colName&&"glorio"!=colName||under10(colName,e),"compagnia"!=colName&&"brama"!=colName&&"fama"!=colName&&"talento"!=colName&&"bravado"!=colName&&"vivido"!=colName||under21(colName,e),"piora"!=colName&&"lapel-flower"!=colName||over21(colName,e)}function under5(e,i){$parent=$(".product-grid-item"),$child=$parent.children(),$rd_img=$("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>"),console.log(i),"y"==i?rd_pos=RdInt(0,2):"z"==i&&(rd_pos=RdInt(5,7)),0==rd_pos?$rd_img.insertBefore($child.eq(3)):1==rd_pos?$rd_img.insertAfter($child.eq(4)):5==rd_pos?$rd_img.insertAfter($child.eq(1)):6==rd_pos&&$rd_img.insertAfter($child.eq(4)),getImgD(e),console.log(e),console.log("pos="+rd_pos)}function under10(e,i){$parent=$(".product-grid-item"),$child=$parent.children(),$rd_img=$("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>"),$rd_img2=$("<div class='pd_random pd_medium col-lg-6 col-md-8 col-6'></div>"),console.log(i),"glorio"==e?("y"==i?rd_pos=RdInt(0,2):"z"==i&&(rd_pos=6),0==rd_pos?($rd_img.insertBefore($child.eq(0)),$rd_img2.insertBefore($child.eq(5))):1==rd_pos?($rd_img2.insertBefore($child.eq(2)),$rd_img.insertBefore($child.eq(2))):5==rd_pos?$rd_img.insertAfter($child.eq(2)):6==rd_pos&&$rd_img.insertAfter($child.eq(1)),getImgC(e,rd_pos),console.log(e),console.log("pos="+rd_pos)):"rispetto"==e&&("y"==i?rd_pos=RdInt(0,3):"z"==i&&(rd_pos=RdInt(5,8)),0==rd_pos?($rd_img2.insertBefore($child.eq(2)),$rd_img.insertBefore($child.eq(2))):1==rd_pos?($rd_img.insertAfter($child.eq(6)),$rd_img2.insertBefore($child.eq(2))):2==rd_pos?($rd_img.insertBefore($child.eq(0)),$rd_img2.insertBefore($child.eq(5))):5==rd_pos?$rd_img.insertAfter($child.eq(4)):6==rd_pos?$rd_img.insertAfter($child.eq(1)):7==rd_pos&&$rd_img.insertAfter($child.eq(6)),2==rd_pos||7==rd_pos?getImgB(e,rd_pos):getImgC(e,rd_pos),console.log(e),console.log("pos="+rd_pos))}function under21(e,i){$parent=$(".product-grid-item"),$child=$parent.children(),$rd_img=$("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>"),$rd_img2=$("<div class='pd_random pd_medium col-lg-6 col-md-8 col-6'></div>"),$rd_img3=$("<div class='pd_random pd_small pd_small2 col-lg-3 col-md-4 col-6 product-items'></div>"),"y"==i?rd_pos=RdInt(0,3):"z"==i&&(rd_pos=RdInt(5,8)),"talento"==e?(0==rd_pos?(bigPos(4,0),$rd_img.insertBefore($child.eq(5)),$rd_img2.insertAfter($child.eq(9))):1==rd_pos?(bigPos(5,6),$rd_img.insertAfter($child.eq(4)),$rd_img2.insertBefore($child.eq(0))):2==rd_pos?(bigPos(9,5),$rd_img.insertBefore($child.eq(2)),$rd_img2.insertAfter($child.eq(1))):5==rd_pos?($rd_img.insertAfter($child.eq(1)),$rd_img2.insertBefore($child.eq(5))):6==rd_pos?($rd_img.insertAfter($child.eq(5)),$rd_img2.insertBefore($child.eq(0))):7==rd_pos&&($rd_img.insertAfter($child.eq(11)),$rd_img2.insertBefore($child.eq(6))),2==rd_pos||7==rd_pos?getImgA(e,rd_pos):getImgB(e,rd_pos),console.log(i),console.log(e),console.log("pos="+rd_pos)):"brama"==e?(0==rd_pos?(bigPos(9,5),$rd_img.insertBefore($child.eq(2)),$rd_img2.insertAfter($child.eq(1))):1==rd_pos?(bigPos(5,6),$rd_img.insertAfter($child.eq(4)),$rd_img2.insertBefore($child.eq(0))):2==rd_pos?(bigPos(4,0),$rd_img.insertBefore($child.eq(5)),$rd_img2.insertAfter($child.eq(9))):5==rd_pos?($rd_img.insertBefore($child.eq(0)),$rd_img2.insertAfter($child.eq(5))):6==rd_pos?($rd_img.insertBefore($child.eq(4)),$rd_img2.insertAfter($child.eq(0))):7==rd_pos&&($rd_img.insertBefore($child.eq(10)),$rd_img2.insertAfter($child.eq(6))),getImgB(e,rd_pos),console.log(e),console.log("pos="+rd_pos)):"fama"==e?(0==rd_pos?(bigPos(4,0),$rd_img.insertBefore($child.eq(5)),$rd_img2.insertAfter($child.eq(9))):1==rd_pos?(bigPos(9,5),$rd_img.insertBefore($child.eq(2)),$rd_img2.insertAfter($child.eq(1))):2==rd_pos?(bigPos(10,6),$rd_img.insertBefore($child.eq(11)),$rd_img2.insertBefore($child.eq(0))):5==rd_pos?($rd_img.insertBefore($child.eq(0)),$rd_img2.insertBefore($child.eq(6))):6==rd_pos?($rd_img.insertBefore($child.eq(2)),$rd_img2.insertBefore($child.eq(8))):7==rd_pos&&($rd_img.insertBefore($child.eq(7)),$rd_img2.insertBefore($child.eq(4))),2==rd_pos||7==rd_pos?getImgA(e,rd_pos):getImgB(e,rd_pos),console.log(e),console.log("pos="+rd_pos)):"compagnia"==e?(0==rd_pos?(bigPos(4,0),$rd_img.insertBefore($child.eq(5)),$rd_img2.insertAfter($child.eq(9))):1==rd_pos?(bigPos(9,5),$rd_img.insertBefore($child.eq(2)),$rd_img2.insertAfter($child.eq(1))):2==rd_pos?(bigPos(9,10),$rd_img.insertBefore($child.eq(0)),$rd_img2.insertBefore($child.eq(5))):5==rd_pos?($rd_img.insertBefore($child.eq(2)),$rd_img2.insertBefore($child.eq(5))):6==rd_pos?($rd_img.insertBefore($child.eq(2)),$rd_img2.insertBefore($child.eq(9))):7==rd_pos&&($rd_img.insertBefore($child.eq(9)),$rd_img2.insertBefore($child.eq(3))),2==rd_pos||7==rd_pos?getImgA(e,rd_pos):getImgC(e,rd_pos),console.log(e),console.log("pos="+rd_pos)):"bravado"==e?(0==rd_pos?(bigPos(4,0),$rd_img.insertBefore($child.eq(5)),$rd_img2.insertAfter($child.eq(9)),getImgC(e,rd_pos)):1==rd_pos?(bigPos(9,10),$rd_img.insertBefore($child.eq(0)),$rd_img2.insertBefore($child.eq(5)),getImgB(e,rd_pos)):2==rd_pos?(bigPos(4,0),$rd_img.insertAfter($child.eq(8)),$rd_img2.insertAfter($child.eq(13)),getImgB(e,rd_pos)):5==rd_pos?($rd_img.insertBefore($child.eq(0)),$rd_img2.insertAfter($child.eq(5)),$rd_img3.insertAfter($child.eq(11)),getImgE(e,rd_pos,i)):6==rd_pos?($rd_img.insertBefore($child.eq(2)),$rd_img2.insertAfter($child.eq(9)),$rd_img3.insertAfter($child.eq(4)),getImgF(e,rd_pos,i)):7==rd_pos&&($rd_img.insertBefore($child.eq(0)),$rd_img2.insertAfter($child.eq(9)),$rd_img3.insertAfter($child.eq(3)),getImgF(e,rd_pos,i)),console.log(e),console.log("pos="+rd_pos)):"vivido"==e&&(0==rd_pos?(bigPos(9,10),$rd_img.insertAfter($child.eq(4)),$rd_img2.insertBefore($child.eq(0)),getImgB(e,rd_pos)):1==rd_pos?(bigPos(4,0),$rd_img.insertBefore($child.eq(5)),$rd_img2.insertAfter($child.eq(9)),getImgB(e,rd_pos)):2==rd_pos?(bigPos(13,9),$rd_img.insertAfter($child.eq(2)),$rd_img2.insertBefore($child.eq(3))):5==rd_pos?($rd_img.insertAfter($child.eq(2)),$rd_img2.insertAfter($child.eq(8)),$rd_img3.insertAfter($child.eq(13)),getImgG(e,rd_pos,i)):6==rd_pos?($rd_img.insertAfter($child.eq(1)),$rd_img2.insertAfter($child.eq(9)),$rd_img3.insertAfter($child.eq(4)),getImgH(e,rd_pos,i)):7==rd_pos&&($rd_img.insertAfter($child.eq(4)),$rd_img2.insertAfter($child.eq(12)),$rd_img3.insertAfter($child.eq(7)),getImgG(e,rd_pos,i)),rd_pos<3&&getImgB(e,rd_pos),console.log(e),console.log("pos="+rd_pos))}function over21(e,i){$parent=$(".product-grid-item"),$child=$parent.children(),$rd_img=$("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>"),$rd_img2=$("<div class='pd_random pd_medium col-lg-6 col-md-8 col-6'></div>"),"y"==i?rd_pos=RdInt(0,2):"z"==i&&(rd_pos=RdInt(5,7)),(rd_pos=0)==rd_pos?(bigPos(4,0),$rd_img.insertBefore($child.eq(5)),$rd_img2.insertAfter($child.eq(9))):1==rd_pos&&(bigPos(9,10),$rd_img.insertBefore($child.eq(0)),$rd_img2.insertBefore($child.eq(5))),console.log(i),console.log(e),console.log("pos="+rd_pos)}function getImgI(e){0==e||5==e?e="A":1!=e&&6!=e||(e="B"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A1.png","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A2.png","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B1.png","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B2.png"],imgURLs2=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_A1.png","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_B1.png","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C1.png","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C2.png"],imgset()}function getImgA(e,i){0==i||5==i?i="A":1==i||6==i?i="B":2!=i&&7!=i||(i="C"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"1.png?54664"],imgURLs2=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"1.png?54664"],imgset(e)}function getImgB(e,i){0==i||5==i?i="A":1==i||6==i?i="B":2!=i&&7!=i||(i="C"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"1.png?54664"],imgURLs2="bravado"==e?["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_1.png?54664","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_2.png?54664"]:["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"1.png?54664","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"2.png?54664"],imgset(e)}function getImgC(e,i){0==i||5==i?i="A":1==i||6==i?i="B":2!=i&&7!=i||(i="C"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"1.png?54664","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"2.png?54664"],imgURLs2=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"1.png?54664"],imgset(e)}function getImgD(e){imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_1.png?54664","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_2.png?54664","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_3.png?54664"],imgset(e)}function getImgE(e,i,o){0==i||5==i?i="A":1==i||6==i?i="B":2!=i&&7!=i||(i="C"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"1.png?54664","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"2.png?54664"],imgURLs2=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"1.png?54664"],imgURLs3=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_T_C2.png?93416"],imgset(e,o)}function getImgF(e,i,o){0==i||5==i?i="A":1==i||6==i?i="B":2!=i&&7!=i||(i="C"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_T_"+i+".png?934164"],imgURLs2=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_1.png?934164","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_2.png?934164"],imgURLs3=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_T_"+i+"2.png?95193"],imgset(e,o)}function getImgG(e,i,o){0==i||5==i?i="A":1==i||6==i?i="B":2!=i&&7!=i||(i="C"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"1.png?934164"],imgURLs2=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"2.png?93887","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"3.png?93887"],imgURLs3=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+".png?934164"],imgset(e,o)}function getImgH(e,i,o){0==i||5==i?i="A":1==i||6==i?i="B":2!=i&&7!=i||(i="C"),imgURLs=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_A.png?934164"],imgURLs2=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"1.png?93887","https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+e+"_"+i+"2.png?93887"],imgURLs3=["https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+e+"_"+i+"1.png?934164"],imgset(e,o)}function imgset(e,i){if($rdImg=$(".pd_small"),$rdImg2=$(".pd_medium"),$rdImg3=$(".pd_small2"),$.each($rdImg,function(e,i){!function(e){var i=Math.floor(Math.random()*imgURLs.length);$(e).css({"background-image":"url("+imgURLs[i]})}(i)}),"blanc"!=e){$.each($rdImg2,function(e,i){!function(e){var i=Math.floor(Math.random()*imgURLs2.length);$(e).css({"background-image":"url("+imgURLs2[i]})}(i)}),"z"==i&&$.each($rdImg3,function(e,i){!function(e){var i=Math.floor(Math.random()*imgURLs3.length);$(e).css({"background-image":"url("+imgURLs3[i]})}(i)})}}function RdInt(e,i){e=Math.ceil(e),i=Math.floor(i);return Math.floor(Math.random()*(i-e))+e}function bigPos(e,i){var o;for($child.eq(e).before("<div class='pd_group col-lg-6 col-md-8 col-6 product-items'></div>"),$group=$(".pd_group"),$child.eq(e).appendTo($group),$child.eq(e).removeClass("col-lg-3 col-md-4 col-6"),$child.eq(i).before("<div class='pd_group2 col-lg-6 col-md-12 col-6'></div>"),$group2=$(".pd_group2"),o=i;o<i+4;o++)$child.eq(o).appendTo($group2),$child.eq(o).removeClass("col-lg-3 col-md-4"),$child.eq(o).addClass("col-lg-6 col-md-4 col-6"),$child.eq(o).css("float","left")}function bigPos2(e,i){var o;for($child.eq(e).before("<div class='pd_group3 col-lg-6 col-md-8 col-6 product-items'></div>"),$group=$(".pd_group3"),$child.eq(e).appendTo($group),$child.eq(e).removeClass("col-lg-3 col-md-4 col-6"),$child.eq(i).before("<div class='pd_group4 col-lg-6 col-md-12 col-6'></div>"),$group2=$(".pd_group4"),o=i;o<i+4;o++)$child.eq(o).appendTo($group2),$child.eq(o).removeClass("col-lg-3 col-md-4"),$child.eq(o).addClass("col-lg-6 col-md-4 col-6"),$child.eq(o).css("float","left")}function bigPos3(e,i){var o;for($child.eq(e).before("<div class='pd_group5 col-lg-6 col-md-8 col-6 product-items'></div>"),$group=$(".pd_group5"),$child.eq(e).appendTo($group),$child.eq(e).removeClass("col-lg-3 col-md-4 col-6"),$child.eq(i).before("<div class='pd_group6 col-lg-6 col-md-12 col-6'></div>"),$group2=$(".pd_group6"),o=i;o<i+4;o++)$child.eq(o).appendTo($group2),$child.eq(o).removeClass("col-lg-3 col-md-4"),$child.eq(o).addClass("col-lg-6 col-md-4 col-6"),$child.eq(o).css("float","left")}$(document).ready(function(){$(".filter-wr .sidebar-tag .content .widget-content").find("input:checked").length||$("body").hasClass("mobile")||(init(),pdRandom(),hideBefore())});
      }
      
    },
    _pdlistGrid: function(){
      var che = $(".colection_gutter .collection-page .products-grid.product-grid-item > div").length;
    },
    _rdimgLoad: function(clickcount,colName){
      // console.log(clickcount);
      if(($(".filter-wr .sidebar-tag .content .widget-content").find("input:checked").length)||($("body").hasClass("mobile"))){
        return;
      }else{
        var $check = null;
        if($("body").hasClass("tablet")){
          $check = "z";
        }else{
          $check = "y";
        }
        function init(){}
        // console.log(colName)
        if(colName == "vivido"){
          loadmore();
        }

        if((colName =="cosa-piora")||(colName =="lapel-flower")){
          loadmore2(clickcount,$check);
        }
      }
      
      function loadmore2(clickcount,$check){
        $parent = $(".product-grid-item");
        $child = $parent.children();
        
        var Num = 0;
        var $target = null;

        $rd_img = $("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img3 = $("<div class='pd_random pd_small pd_small2 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img4 = $("<div class='pd_random pd_small pd_small3 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img5 = $("<div class='pd_random pd_small pd_small4 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img6 = $("<div class='pd_random pd_small pd_small5 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img7 = $("<div class='pd_random pd_small pd_small6 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img8 = $("<div class='pd_random pd_small pd_small7 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img9 = $("<div class='pd_random pd_small pd_small8 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img10 = $("<div class='pd_random pd_small pd_small9 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img11 = $("<div class='pd_random pd_small pd_small10 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img12 = $("<div class='pd_random pd_small pd_small11 col-lg-3 col-md-4 col-6 product-items'></div>");
        $rd_img13 = $("<div class='pd_random pd_small pd_small12 col-lg-3 col-md-4 col-6 product-items'></div>");
        
        
        $rd_img2 = $("<div class='pd_random pd_medium col-lg-6 col-md-8 col-6'></div>");
        $rd_img22 = $("<div class='pd_random pd_medium2 col-lg-6 col-md-8 col-6'></div>");
        $rd_img222 = $("<div class='pd_random pd_medium3 col-lg-6 col-md-8 col-6'></div>");
        $rd_img2222 = $("<div class='pd_random pd_medium4 col-lg-6 col-md-8 col-6'></div>");
        $rd_img22222 = $("<div class='pd_random pd_medium5 col-lg-6 col-md-8 col-6'></div>");
        
        if($check== "y"){
          if($child.eq(1).hasClass("pd_group")){
            $target = "A"
            if(clickcount == 1){
              $rd_img22.insertAfter($child.eq(16));
              
              //img
              getImgK2(colName,$target,clickcount,$rd_img22);
            }else if(clickcount == 2){
              $rd_img3.insertBefore($child.eq(28));
              $rd_img4.insertAfter($child.eq(37));
              
              // img
              getImgL($target,clickcount,$rd_img3,$rd_img4);
            }else if(clickcount == 3){

              // 2x2 img position
              bigPos2(57,53);

              // 1x1, 2x1 img position
              $rd_img222.insertAfter($child.eq(45));
              $rd_img5.insertBefore($child.eq(46));
              
              // img
              getImgL($target,clickcount,$rd_img5,$rd_img222);
            }else if(clickcount == 4){
              if (colName =="piora"){
                $rd_img2222.insertAfter($child.eq(68));
              }else{
                $rd_img2222.insertAfter($child.eq(60));
              }
              
              //img
              getImgK2(colName,$target,clickcount,$rd_img2222);
            }else if(clickcount == 5){
              if (colName =="piora"){
                return;
              }else{
                $rd_img6.insertAfter($child.eq(74));
                $rd_img7.insertAfter($child.eq(82));
                
                // img
                getImgL($target,clickcount,$rd_img6,$rd_img7);
              }

            }else if(clickcount == 6){

              // 2x2 img position
              bigPos3(92,88);

              // 1x1, 2x1 img position
              $rd_img22222.insertAfter($child.eq(101));
              $rd_img8.insertAfter($child.eq(96));
              
              // img
              getImgL($target,clickcount,$rd_img8,$rd_img22222);
            }else if(clickcount == 7){
              $rd_img9.insertAfter($child.eq(108));
              
              //img
              getImgK2(colName,$target,clickcount,$rd_img9);
            }

          }else if($child.eq(11).hasClass("pd_group")){
            $target = "B"
            if(clickcount == 1){
              $rd_img22.insertAfter($child.eq(18));
              
              //img
              getImgK2(colName,$target,clickcount,$rd_img22);
            }else if(clickcount == 2){
              $rd_img3.insertBefore($child.eq(28));
              $rd_img4.insertAfter($child.eq(37));
              
              // img
              getImgL($target,clickcount,$rd_img3,$rd_img4);
            }else if(clickcount == 3){

              // 2x2 img position
              bigPos2(57,53);

              // 1x1, 2x1 img position
              $rd_img222.insertAfter($child.eq(45));
              $rd_img5.insertBefore($child.eq(46));
              
              // img
              getImgL($target,clickcount,$rd_img5,$rd_img222);
            }else if(clickcount == 4){
              $rd_img2222.insertAfter($child.eq(66));

              //img
              getImgK2(colName,$target,clickcount,$rd_img2222);
            }else if(clickcount == 5){
              if (colName =="piora"){
                return;
              }else{
                $rd_img6.insertBefore($child.eq(72));
                $rd_img7.insertAfter($child.eq(81));
                
                // img
              getImgL($target,clickcount,$rd_img6,$rd_img7);
              }
            }else if(clickcount == 6){
              // 2x2 img position
              bigPos3(97,98);

              // 1x1, 2x1 img position
              $rd_img22222.insertBefore($child.eq(88));
              $rd_img8.insertAfter($child.eq(96));
              
              // img
              getImgL($target,clickcount,$rd_img8,$rd_img22222);
            }else if(clickcount == 7){
              $rd_img9.insertAfter($child.eq(104));
              
              //img
              getImgK2(colName,$target,clickcount,$rd_img9);
            }
          }
        }else if($check =="z"){
          if($child.eq(15).hasClass("pd_medium")){
            $target = "A"
            if(clickcount == 1){
              $rd_img4.insertAfter($child.eq(24));
              
              // img
              getImgK(colName,$target,clickcount,$rd_img4);
            }else if(clickcount == 2){
              $rd_img5.insertAfter($child.eq(31));
              $rd_img6.insertAfter($child.eq(38));
              $rd_img22.insertAfter($child.eq(45));
              
              // img
              getImgM($target,clickcount,$rd_img5,$rd_img6,$rd_img22);
            }else if(clickcount == 3){
              $rd_img7.insertAfter($child.eq(54));
              
              // img
              getImgK(colName,$target,clickcount,$rd_img7);
            }else if(clickcount == 4){
              $rd_img8.insertAfter($child.eq(63));
              $rd_img9.insertAfter($child.eq(77));
              $rd_img222.insertAfter($child.eq(69));
              
              // fama
              $rd_img222.addClass("pd_right");
              
              //img
              getImgM($target,clickcount,$rd_img8,$rd_img9,$rd_img222);
            }else if(clickcount == 5){
              if (colName =="piora"){
                $rd_img22222.insertAfter($child.eq(84));
                
                // img
                getImgK(colName,$target,clickcount,$rd_img22222);
              }else{
                $rd_img10.insertAfter($child.eq(89));
                
                // img
                getImgK(colName,$target,clickcount,$rd_img10);
              }
            }else if(clickcount == 6){
              $rd_img11.insertAfter($child.eq(104));
              $rd_img12.insertAfter($child.eq(107));
              $rd_img2222.insertAfter($child.eq(96));
              
              //img
              getImgM($target,clickcount,$rd_img11,$rd_img12,$rd_img2222);
            }
            
          }else if($child.eq(7).hasClass("pd_medium")){
            $target = "B";
            if(clickcount == 1){
              $rd_img4.insertAfter($child.eq(22));
              
              // img
              getImgK(colName,$target,clickcount,$rd_img4);
            }else if(clickcount == 2){
              $rd_img5.insertAfter($child.eq(35));
              $rd_img6.insertAfter($child.eq(42));
              $rd_img22.insertAfter($child.eq(32));
              
              // img
              getImgM($target,clickcount,$rd_img5,$rd_img6,$rd_img22);
            }else if(clickcount == 3){
              $rd_img7.insertAfter($child.eq(51));
              
              // img
              getImgK(colName,$target,clickcount,$rd_img7);
            }else if(clickcount == 4){
              $rd_img8.insertAfter($child.eq(70));
              $rd_img9.insertAfter($child.eq(77));
              $rd_img222.insertAfter($child.eq(64));
              
              // fama
              $rd_img222.addClass("pd_right");
              // img
              getImgM($target,clickcount,$rd_img8,$rd_img9,$rd_img222);
            }else if(clickcount == 5){
              if (colName =="piora"){
                $rd_img22222.insertAfter($child.eq(84));
                
                // img
                getImgK(colName,$target,clickcount,$rd_img22222);
              }else{
                $rd_img10.insertAfter($child.eq(88));
                
                // img
              getImgK(colName,$target,clickcount,$rd_img10);
              }
            }else if(clickcount == 6){
              $rd_img11.insertAfter($child.eq(102));
              $rd_img12.insertAfter($child.eq(109));
              $rd_img2222.insertAfter($child.eq(95));
              
              // img
              getImgM($target,clickcount,$rd_img11,$rd_img12,$rd_img2222);
            }
          }
          
            
        };
        
        // Tablet
        function getImgK(colName,$target,clickcount,element){
          if(clickcount == 1){
            if($target == "A"){
              // 4
              imgURLs = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C1.png?94555"
              ];
            }else if($target == "B"){
              // 4
              imgURLs = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B1.png?94555"
              ];
            }
          }else if(clickcount == 3){
            // 8
            imgURLs = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_T_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_C1.png?94555"
            ];
          }else if(clickcount == 5){
            if(colName == "piora"){
              // 12
              imgURLs = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_A2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_B1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_B2.png?94555"
              ];
            }else{
              // 12
              imgURLs = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_brama_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_brama_B1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_brama_C1.png?94555"
              ];
            }
          }
          
          imgset2(clickcount,element);
        }
        
        // PC 
         function getImgK2(colName,$target,clickcount,element){
           if(clickcount == 1){
             if($target == "A"){
               // 3-2x1
               imgURLs = [
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_A1.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_B1.png?94555",
               ];
             }else{
               // 3-2x1
               imgURLs = [
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_A2.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_C2.png?94555"
               ];
             }
           }else if(clickcount == 4){
             if((colName == "piora")||($target == "B")){
               // 8-2x1
               imgURLs = [
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_A1.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_A2.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_B1.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_talento_B2.png?94555"
               ];
             }else{
               // 8-2x1
               imgURLs = [
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_fama_A1.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_fama_A2.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_fama_B1.png?94555",
                 "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_fama_B2.png?94555"
               ];
             }
           }else if(clickcount == 7){
             // 13-1x1
             imgURLs = [
               "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_blanc_A1.png?94555",
               "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_blanc_A2.png?94555",
               "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_blanc_A3.png?94555"
             ];
           }

           imgset2(clickcount,element);
         }
        
        function getImgL($target,clickcount,element,element2){
          if(clickcount == 2){
            // 4-1x1
            imgURLs = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C2.png?94555"
            ];

            // 5-1x1
            imgURLs2 = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_A2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_T_C2.png?94555"
            ];
          }else if(clickcount == 3){
            // 7-1x1
            imgURLs = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_T_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_C1.png?94555"
            ];
            
            // 6-2x1
            imgURLs2 = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_bravado_C1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_bravado_C2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_bravado_A1.png?94555"
            ];

          }else if(clickcount == 5){
            // 9-1x1
            imgURLs = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_talento_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_talento_B1.png?94555"
            ];
            
            // 10-1x1
            imgURLs2 = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_brama_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_brama_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_brama_C1.png?94555"
            ];
          }else if(clickcount == 6){
            // 11-1x1
            imgURLs = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_A2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_C1.png?94555"
            ];

            if($target == "A"){
              // 12-2x1
              imgURLs2 = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_compagnia_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_compagnia_B1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_compagnia_C1.png?94555"
              ];
            }else if($target == "B"){
              // 11-2x1
              imgURLs2 = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_A2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_B1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_B2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_C1.png?94555"
              ];
            }

          }
          
          imgset3(clickcount,element,element2);
        }
        
        
        function getImgM($target,clickcount,element,element2,element3){
          if(clickcount == 2){
            if($target == "A"){
              // 5-1x1
              imgURLs = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C2.png?94555"
              ];

              // 6-1x1
              imgURLs2 = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_A2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_T_C2.png?94555"
              ];

              // 7-2x1
              imgURLs3 = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_bravado_C1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_bravado_C2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_bravado_A1.png?94555"
              ];
            }else if($target == "B"){
              // 6-1x1
              imgURLs = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C2.png?94555"
              ];

              // 7-1x1
              imgURLs2 = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_A1.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_A2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_bravado_T_C2.png?94555"
              ];

              // 5-2x1
              imgURLs3 = [
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_A2.png?94555",
                "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_B2.png?94555"
              ];
            }
            
          }else if(clickcount == 4){
            // 9-1x1
            imgURLs = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_fama_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_fama_B1.png?94555"
            ];
            
            // 11-1x1
            imgURLs2 = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_talento_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_talento_B1.png?94555"
            ];
            
            // 10-2x1
            imgURLs3 = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_fama_A2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_fama_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_fama_B2.png?94555"
            ];
            
          }else if(clickcount == 6){
            // 14-1x1
            imgURLs = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_B1.png?94555"
            ];
            
            // 15-1x1
            imgURLs2 = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_A2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_compagnia_C1.png?94555"
            ];
            
            // 13-2x1
            imgURLs3 = [
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_A1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_A2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_B1.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_B2.png?94555",
              "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_brama_C1.png?94555"
            ];
            
          }
          
          imgset4(clickcount,element,element2,element3);
        }
        
        
        function imgset2(clickcount,element){
          $.each(element, function(index, element){
            displayImg(element);
          });

          function displayImg(element){
            var randomIndex = Math.floor(Math.random()*imgURLs.length);
            $(element).css({
              "background-image" : "url("+ imgURLs[randomIndex]+")"
            });

          };
        };
        
        function imgset3(clickcount,element,element2){
          $.each(element, function(index, element){
            displayImg(element);
          });
          
          $.each(element2, function(index, element2){
            displayImg2(element2);
          });

          function displayImg(element){
            var randomIndex = Math.floor(Math.random()*imgURLs.length);
            $(element).css({
              "background-image" : "url("+ imgURLs[randomIndex]+")"
            });
          };
          
          function displayImg2(element2){
            var randomIndex = Math.floor(Math.random()*imgURLs2.length);
            $(element2).css({
              "background-image" : "url("+ imgURLs2[randomIndex]+")"
            });
          };
        };
        
        
        function imgset4(clickcount,element,element2,element3){
          $.each(element, function(index, element){
            displayImg(element);
          });
          
          $.each(element2, function(index, element2){
            displayImg2(element2);
          });
          
          $.each(element3, function(index, element3){
            displayImg3(element3);
          });

          function displayImg(element){
            var randomIndex = Math.floor(Math.random()*imgURLs.length);
            $(element).css({
              "background-image" : "url("+ imgURLs[randomIndex]+")"
            });
          };
          
          function displayImg2(element2){
            var randomIndex = Math.floor(Math.random()*imgURLs2.length);
            $(element2).css({
              "background-image" : "url("+ imgURLs2[randomIndex]+")"
            });
          };
          
          function displayImg3(element3){
            var randomIndex = Math.floor(Math.random()*imgURLs3.length);
            $(element3).css({
              "background-image" : "url("+ imgURLs3[randomIndex]+")"
            });
          };


        };
        
        
        
//         function getImgJ(rd_pos){
//           // change num to ABC
//           if((rd_pos == 0)||(rd_pos == 5)){
//             rd_pos = "A"
//           }else if((rd_pos == 1)||(rd_pos == 6)){
//             rd_pos = "B"
//           };

//           // 1x1
//           imgURLs= [
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A1.png",
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A2.png",
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B1.png",
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B2.png"
//           ];

//           // 2x1
//           imgURLs2= [
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_A1.png",
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_B1.png",
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C1.png",
//             "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C2.png",
//           ];

//             // set img function
//             imgset();

//             }
        
        
        
      }
      
      
      
      
      function loadmore(){
        $parent = $(".product-grid-item");
        $child = $parent.children();

        $rd_img = $("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>");

        if($("body").hasClass("tablet")){
          imgURLs = [
            "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B1.png?94555",
            "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B2.png?94555",
            "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A1.png?94555"
          ]

          if($child.eq(10).hasClass("pd_medium")){
            // A set
//             console.log("it's A");
            $rd_img.insertAfter($child.eq(19));
            $rd_img.css({
              "background-image" : 'url("'+ imgURLs[0] + '")'
            });
          }else if($child.eq(12).hasClass("pd_medium")){
            // B set
//             console.log("it's B");
            $rd_img.insertAfter($child.eq(21));
            $rd_img.css({
              "background-image" : 'url("'+ imgURLs[1] + '")'
            });
          }else if($child.eq(15).hasClass("pd_medium")){
            // C set
//             console.log("it's C");
            $rd_img.insertAfter($child.eq(22));
            $rd_img.css({
              "background-image" : 'url("'+ imgURLs[2] + '")'
            });
          }
        }else{
          imgURLs = [
            "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A3.png",
            "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B3.png",
            "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C3.png"
          ]

          if($child.eq(11).hasClass("pd_group")){
            // A set
            //console.log("it's A" + imgURLs[0]);
            $rd_img.insertBefore($child.eq(16));
            $rd_img.css({
              "background-image" : 'url("'+ imgURLs[0] + '")'
            });

          }else if($child.eq(1).hasClass("pd_group")){
            // B set
           // console.log("it's B" + imgURLs[1]);
            $rd_img.insertBefore($child.eq(13));
            $rd_img.css({
              "background-image" : 'url("'+ imgURLs[1] + '")'
            });
          }else if($child.eq(12).hasClass("pd_group")){
            // C set
            //console.log("it's C" + imgURLs[2]);
            $rd_img.insertBefore($child.eq(17));
            $rd_img.css({
              "background-image" : 'url("'+ imgURLs[2] + '")'
            });
          }
        };
      };

      
      
    },
    _sidebarparams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var e, mt = 0, n = location.search.substr(1).split("&"); mt < n.length; mt++) {
          e = n[mt].split("=");
          if ($.length > 1) {
            Shopify.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1])
          }
        }
      }
    },

    _sidebar: function() {
      if ($("#filter-sidebar").length > 0) {
        mt._sidebarparams();
        mt._evensidebar();
        mt._accordionsibar();
        mt._clearsidebar();
        mt._clearsidebarall();
        mt._colorswatchgridInit();
        mt._quickview();
      }
    },

    _wishlist: function() {
      $(".grid-item button.wishlist").click(function(n) {
       n.preventDefault();
        var r = $(this).parent();
        var i = r.parents(".grid-item");
        $.ajax({
          type: "POST",
          url: "/contact",
          data: r.serialize(),
          beforeSend: function() {
            mt.showLoading()
          },
          success: function(n) {
            mt.hideLoading();
            r.html('<span class="tooltips">WISHLIST</span><a class="wishlist harman_btn3 wish_on" href="/pages/wish-list"><img class="pd_icon icon_heart" src="https://cdn.shopify.com/s/files/1/0213/5710/1156/files/icon_heart_on.png"/></a>');           
          },
          error: function(n, r) {
            mt.hideLoading();
            $(".loading").hide();
          }
        })
      })
    },
    _productwishlist: function() {
      $(".product button.wishlist").click(function(n) {
        n.preventDefault();
        var r = $(this).parent();
        var i = r.parents(".grid-item");
        $.ajax({
          type: "POST",
          url: "/contact",
          data: r.serialize(),
          beforeSend: function() {
            mt.showLoading()
          },
          success: function(n) {
            mt.hideLoading();
            r.html('<a class="wishlist harman_btn3" href="/pages/wish-list" data-toggle="tooltip" data-placement="top"><i class="cs-font clever-icon-heart-2"></i></a>');
           
          },
          error: function(n, r) {
            mt.hideLoading();
            $(".loading").hide();

            mt.showBox(".ajax-error-cbox")
          }
        })
      })
    },
    _quickviewwishlist: function(){
    },
    _removewishlist: function() {
      $(".btn-remove-wishlist").each(function(){
        $(this).click(function(n) {
          n.preventDefault();
          var r = $(this).parents("tr");
          var i = r.find(".tag-id").val();
          var s = jQuery("#remove-wishlist-form-"+i);
          s.find("input[name='contact[tags]']").val("x" + i);
          r.fadeOut(300);
          setTimeout(s.submit(),3e3);
        })
      });
      
    },
    _resizeImage: function() {
      if (window.product_image_resize) {
        $(".products-grid .product-image img").fakecrop({
          fill: window.images_size.is_crop,
          widthSelector: ".products-grid .grid-item .product-image",
          ratioWrapper: window.images_size
        })
      }
    },

    // message-modal
    showBox: function(n) {
      $(n).fadeIn(500);
      // off modal
//       mt.atTimeout = setTimeout(function() {
//         $(n).fadeOut(500)
//       }, 2500)
    },
    _mesagebox: function() {
      $(".continue-shopping").click(function() {
        clearTimeout(mt.atTimeout);
        $(".ajax-success-cbox").fadeOut(500)
      });
      $(".close-cbox").click(function() {
        clearTimeout(mt.atTimeout);
        $(".ajax-success-cbox").fadeOut(500)
      })
    },

    _zoomimage: function() {
      
      var mag;
      if ($("#product-featured-image").length > 0) {
        function magZoom(){
          var windowsize = $(window).width();

          if(windowsize > 1080){mag = 0.75;}
          if(windowsize < 1081 && windowsize > 767){mag = 0.6;}
          if(windowsize < 1024 && windowsize > 767){mag = 0.7;}
          if(windowsize < 768){mag = 0.56;}

          $('#image_zoom .zoom').trigger('zoom.destroy');
          $("#image_zoom .zoom").zoom({ on:'click', magnify: mag});
        }
        magZoom();
        $(window).resize(magZoom);

        $("#zt_list_product > ul >li").click(function(){
          var zoomzt = $(this).find("img").attr("src");
          $("#image_zoom > .zoom > img").attr("src",zoomzt);
          $('#image_zoom .zoom').trigger('zoom.destroy');
          $("#image_zoom .zoom").zoom({ on:'click', magnify: mag});
        });   
        
      }
    },
    _scrollTop: function() {
      $("#back-top").click(function() {
        $("body,html").animate({
          scrollTop: 0
        }, 400);
        return false
      })
    },
    _overcart : function(){
      if (window.matchMedia("(max-width: 767px)").matches){
        if($("#dropdown-cart .cart-list li.item").length > 6){
          $("#dropdown-cart .cart-list li.item").removeClass("overcart");
          $("#dropdown-cart .cart-list li.item:last-child").addClass("overcart")
        }
      }else{
        if($("#dropdown-cart .cart-list li.item").length > 7){
          $("#dropdown-cart .cart-list li.item").removeClass("overcart");
          $("#dropdown-cart .cart-list li.item:last-child").addClass("overcart");
        }
      }
    },
    _productaddtocart: function() {
      if ($("#product-add-to-cart").length > 0) {
        $("#product-add-to-cart").click(function(n) {
          n.preventDefault();
          if ($(this).attr("disabled") != "disabled") {
            if (!window.ajax_cart) {
              $(this).closest("form").submit()
            } else {
              var cart = $("#add-to-cart-form select[name=id]").val();
              if (!cart) {
                cart = $("#add-to-cart-form input[name=id]").val()
              }
              var i = $("#add-to-cart-form input[name=quantity]").val();
              if (!i) {
                i = 1
              }

              
              var o = $("#product-featured-image").attr("src");
              var u = $(this).parents(".product-shop").find(".product-title h1").text();

              // ITG CODE START
               if($('.customer input[type="checkbox"]').is(':checked')){
                var ck_form =  $(this).closest("form").serialize();
                var email = $('#Recipient-email-product-template').val();
                var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if( email.length == 0) {
                  $('.product-form__recipient-error-message-wrapper').removeAttr('hidden');
                  $('#RecipientForm-email-error-product-template').removeClass('hidden');
                  $('#Recipient-email-product-template').addClass('err');
                }else {
                  $('.product-form__recipient-error-message-wrapper').attr('hidden','hidden');
                  $('#RecipientForm-email-error-product-template').addClass('hidden');
                  $('#Recipient-email-product-template').removeClass('err');
                  $('#product-add-to-cart').addClass('disabled_cart');
                  if(!regex.test(email)) {
                    $('.product-form__recipient-error-message-wrapper_match').removeAttr('hidden');
                  }else{
                    $('.product-form__recipient-error-message-wrapper_match').attr('hidden','hidden');
                    mt._ajaxaddtocart(cart, i, u, o,ck_form);
                  }
                }

              }else{
               mt._ajaxaddtocart(cart, i, u, o);
              }
              // ITG CODE END
              
            }
          }
          return false
        })
      }
    },
    _addtocart: function() {
      if ($(".add-to-cart-btn").length > 0) {
        $(".add-to-cart-btn").click(function(n) {
          n.preventDefault();
           if ($(this).attr("disabled") != "disabled") {
             var cart = $(this).parents(".product-item");
             var i = $(cart).attr("id");
             
             i = i.match(/\d+/g);
             if (!window.ajax_cart) {
               $("#product-actions-" + i).submit()
             } else {
               var s = $("#product-actions-" + i + " select[name=id]").val();
               if (!s) {
                 s = $("#product-actions-" + i + " input[name=id]").val()
               }
               var o = $("#product-actions-" + i + " input[name=quantity]").val();
               if (!o) {
                 o = 1
               }
               if ($("body").attr("id")=="search-results") {
                 var u = $(cart).find(".snize-title").text();
               }else{
                 var u = $(cart).find(".product-title").text();
               }
               var w = $(cart).find("img").attr("src");
               
               var q = $(this).attr("id");
     
               var sale = $(cart).find(".old-price .money").text();
               
               mt._ajaxaddtocart(s, o, u, w, sale, q);
             }
           }
          return false
        })
      }
    },
    showLoading: function() {
//       $(".loadding-collection").show()
    },
    hideLoading: function() {
//       $(".loadding-collection").hide()
    },
     // ITG-CODE START
    _ajaxaddtocart: function(n, r, title, s,gi_form, sale, qty) {
     if($('.customer input[type="checkbox"]').is(':checked')){
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: gi_form,
        dataType: "json",
        async: false,
        cache: false,
        // timeout: 3000,
        beforeSend: function(n) {
          // console.log(qty-r)
          if(qty-r < 0){
            $(".notice_ms").addClass("active");
            $(".notice_overlay").addClass("active");
            $(".notice_ms_wrap p.inventory").removeClass("none");
           
            $(".notice_close").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
            });

            $(".notice_overlay").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
            });
            
            return false;
          }else{
             mt.showLoading();
            jQuery('.mini_cart_header').addClass('loading');
            jQuery('#dropdown-cart').addClass('active');
            jQuery('.wrapper-container').addClass('show-cart');
          }

        },
        success: function(n) { 
          mt.hideLoading();
          mt.showBox();
          
        $(".ajax-success-cbox").find(".show-wishlist").hide();
          // jQuery('#dropdown-cart').addClass('active');
          
          
          //console.log(n)
          mt._updateheadercart(n, gi_form);
          mt.free_shipping();
            jQuery('.mini_cart_header').removeClass('loading');
            $(document).find('#Recipient-email-product-template').val('');
            $(document).find('#Recipient-name-product-template').val('');
            $(document).find('#Recipient-message-product-template').val('');
            $(document).find('#Recipient-send-on-product-template').val('');
            $(document).find('#Recipient-checkbox-product-template').prop('checked',false);
            $(document).find('.check_input_filed').show();
              
              $(document).find('.check_input_filed').hide();
              jQuery('#dropdown-cart').addClass('active');
              jQuery('.wrapper-container').addClass('show-cart');
          
        },
        error: function(n, r) {
          $(".notice_ms").addClass("active");
            $(".notice_overlay").addClass("active");
            $(".notice_ms_wrap p.inventory").removeClass("none")
            $(".product-quickview .limited p").addClass("none");
            $(".product-quickview .limited p.inv_0").removeClass("none");
           
            $(".notice_close").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
              $(".product-quickview").addClass('first');
            });

            $(".notice_overlay").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
              $(".product-quickview").addClass('first');
            });
             
          $(".mini_cart_header").removeClass("loading");
          jQuery('#dropdown-cart').removeClass('active');
          jQuery('.wrapper-container').removeClass('show-cart');
          
        }
      })
     }else{
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: "quantity=" + r + "&id=" + n,
        dataType: "json",
        async: false,
        cache: false,
        timeout: 3000,
        beforeSend: function(n) {
          // console.log(qty-r)
          if(qty-r < 0){
            $(".notice_ms").addClass("active");
            $(".notice_overlay").addClass("active");
            $(".notice_ms_wrap p.inventory").removeClass("none");
           
            $(".notice_close").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
            });

            $(".notice_overlay").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
            });
            
            return false;
          }else{
            mt.showLoading();
            jQuery('.mini_cart_header').addClass('loading');
            jQuery('#dropdown-cart').addClass('active');
            jQuery('.wrapper-container').addClass('show-cart');
          }

        },
        success: function(n) { 
          mt.hideLoading();
          mt.showBox();
          
          $(".ajax-success-cbox").find(".show-wishlist").hide();
          jQuery('#dropdown-cart').addClass('active');
          jQuery('.wrapper-container').addClass('show-cart');
          
          // console.log(n)
          mt._updateheadercart(n, sale);
          mt.free_shipping();
          jQuery('.mini_cart_header').removeClass('loading');
          $('body').css("overflow", "hidden");
          

        },
        error: function(n, r) {
          $(".notice_ms").addClass("active");
            $(".notice_overlay").addClass("active");
            $(".notice_ms_wrap p.inventory").removeClass("none")
            $(".product-quickview .limited p").addClass("none");
            $(".product-quickview .limited p.inv_0").removeClass("none");
           
            $(".notice_close").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
              $(".product-quickview").addClass('first');
            });

            $(".notice_overlay").click(function(){
              $(".notice_ms").removeClass("active");
              $(".notice_overlay").removeClass("active");
              $(".notice_ms p").addClass("none");
              $(".product-quickview").addClass('first');
            });
             
          $(".mini_cart_header").removeClass("loading");
          jQuery('#dropdown-cart').removeClass('active');
          jQuery('.wrapper-container').removeClass('show-cart');
          
        }
      })
     }
    },
   // ITG-CODE END
    _loadslideimagequickview: function(n, cart) {
      var s = Shopify.resizeImage(n.featured_image, "grande");
      var loadingIcon = "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/loadding-icon.gif?81657";
      cart.find(".quickview-featured-image").append('<a><img src="' + s + '" title="' + n.title + '"/></a>');
      if (n.images.length > 0) {
        var o = cart.find(".more-view ul");
        for (i in n.images) {
          var u = Shopify.resizeImage(n.images[i], "grande");
          var a = Shopify.resizeImage(n.images[i], "compact");
          var f = '<li><a href="javascript:void(0)" data-image="' + u + '"><img src="' + a + '"  /></a></li>';
          //off spinner <div style="height: 100%; width: 100%; top: 0; left:0; z-index: 1999; position:absolute; display: none; background:#ffffff; opacity: 0.9;"</div><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + loadingIcon + ') 50% 50% no-repeat; background-size: 40%;"></div>
          o.append(f)
        }
        o.find("a").click(function() {
          var mt = cart.find(".quickview-featured-image img");
          var n = cart.find(".quickview-featured-image div");
          if (mt.attr("src") != jQuery(this).attr("data-image")) {
            mt.attr("src", jQuery(this).attr("data-image"));
            n.show();
            mt.load(function(t) {
              n.hide();
              jQuery(this).unbind("load");
              n.hide()
            })
          }
        });
        if (o.hasClass("quickview-more-views-owlslider")) {
          mt._quickviewthumbslide(o)
        } else {

        }
      } else {
        cart.find(".quickview-more-views").remove();
        cart.find(".quickview-more-view-wrapper-jcarousel").remove()
      }
    },
    _quickview: function() {
      jQuery(".quickview-button a").click(function() {
        var n = jQuery(this).attr("id");
        if(n.indexOf('products')){
        n= n.replace('/products/','');
        }
        var inv = jQuery(this).attr("data-inv");
        var cartinv = jQuery(this).attr("data-cart-inv");

         $("#header-content").addClass("show-quick")
        $(".header-content-overlay").addClass("show-quick").fadeIn();
       
        Shopify.getProduct(n, function(n) {
          var cart = jQuery("#quickview-popup").html();
          jQuery(".product-quickview").addClass('active first');
          
          jQuery(".product-quickview").html(cart);
          var pre = n.description.indexOf('pre-order-label');
          if(pre > 0){
            jQuery('.actions').addClass('pre');
            jQuery('.actions .add-to-cart-btn').append( "<span>Pre-Order</span>" );	
          }
          
          var i = jQuery(".product-quickview");
          
          i.find(".product-title a").html(mt.translateText(n.title));
          i.find(".product-title a").attr("href", n.url);
         
          // view details
          i.find(".view-details-btn a").attr("href", n.url);
          
          
          // inv
          
          var target;
          if(cartinv){
            target = cartinv;
          }else{
            target = inv;
          }

          if(n.type != "Gift Cards"){
          if((target ==2)||(target == 3)){
            i.find(".limited p").addClass("none");
            i.find(".limited p.inv_3").removeClass("none");
          }

          if(target == 1){
            i.find(".limited p").addClass("none");
            i.find(".limited p.inv_1").removeClass("none");
          }
          
          if(target == 0){
            i.find(".limited p").addClass("none");
            i.find(".limited p.inv_0").removeClass("none");
          }
          }
          
          
          var getUrl = window.location.origin;

          i.find(".product_socials_wrapper_inner a.twitter").attr('href','//twitter.com/share?url=' + getUrl + n.url +'&text='+ n.title );
          i.find(".product_socials_wrapper_inner a.facebook").attr('href','https://www.facebook.com/sharer/sharer.php?u='+ getUrl + n.url );
          i.find(".product_socials_wrapper_inner a.google-plus").attr('href','//plus.google.com/share?url='+ getUrl + n.url );
          i.find(".product_socials_wrapper_inner a.pinterest").attr('href','//pinterest.com/pin/create/button/?url='+ getUrl + n.url +'&description='+ n.title );

          if (i.find(".product-vendor span").length > 0) {
            i.find(".product-vendor span").text(n.vendor)
          }

          if (i.find(".product-type span").length > 0) {
            i.find(".product-type span").text(n.type)
          }
          if (i.find(".product-inventory span").length > 0) {
            var o = n.variants[0].inventory_quantity;
            if (o > 0) {
              if (n.variants[0].inventory_management != null) {
                i.find(".product-inventory span").text(o + " in stock")
              } else {
                i.find(".product-inventory span").text("Many in stock")
              }
            } else {
              i.find(".product-inventory span").text("Out of stock")
            }
          }
          if (i.find('.product-description').length > 0) {
            var s = n.description.replace(/(<([^>]+)>)/ig, "");
            var s = s.replace(/\[countdown\](.*)\[\/countdown\]/ig, "");
            var s = s.replace(/\[item-gallery]/ig, "");
            var s = s.replace(/\[label-icon-new]/ig, "");
            var s = s.replace(/\[pre-order-label]/ig, "");
            var s = s.replace(/\[video\](.*)\[\/video\]/ig, "");
            var s = s.replace(/\[short-description\](.*)\[\/short-description\]/ig, "");
            var s = s.replace(/\[custom_html\](.*)\[\/custom_html\]/ig, "");
            var s = s.replace(/\[tabs\](.*)/ig, "");
            var s = s.replace(/\[tab\](.*)\[\/tab\]/ig, "");
            var s = s.replace(/\[tabs\](.*)\[\/tabs\]/ig, "");


            if (window.multi_lang) {
              if (s.indexOf("[lang2]") > 0) {
                var descList = s.split("[lang2]");
                if (jQuery.cookie("language") != null) {
                  s = descList[translator.current_lang - 1];
                } else {
                  s = descList[0];
                }
              }
            }
            s = $.trim(s);     

            // device
            
            // mt._checkDevice();
            
           //  var isDevice = mt._checkDevice();
           // if(isDevice){
           //   s = s.split(" ").splice(0, 20).join(" ") + "...";
           // }else{
           //   s = s.split(" ").splice(0, 23).join(" ") + "...";
           // }

             s = s.split(" ").splice(0, 20).join(" ") + "...";
            i.find('.product-description').text(s);

          } else {
            i.find('.product-description').remove();
          }

          i.find(".product-description").text(s);
          i.find(".price").html(Shopify.formatMoney(n.price, window.money_format));
          i.find(".product-item").attr("id", "product-" + n.id);
          i.find(".variants").attr("id", "product-actions-" + n.id);
          i.find(".variants select").attr("id", "product-select-" + n.id);

          if (n.compare_at_price > n.price) {
            i.find(".compare-price").html(Shopify.formatMoney(n.compare_at_price_max, window.money_format)).show();
            i.find(".price").addClass("on-sale")
          } else {
            i.find(".compare-price").html("").hide();
            i.find(".price").removeClass("on-sale")
          }
          if (!n.available) {
            i.find("select, input, .total-price, .dec, .inc, .variants label").remove();
            i.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass("disabled").attr("disabled", "disabled");
          } else {
            i.find(".total-price span").html(Shopify.formatMoney(n.price, window.money_format));
            if (window.use_color_swatch) {
              mt._createvariantquickviewwatch(n, i)
            } else {
              mt._createquickviewvariant(n, i)
            }
          }
          
          // quickview size
          // mt._createquickviewvariant(n, i)

          i.find(".button").click(function() {
            var n = i.find(".quantity").val(),
                cart = 1;
            if($(this).hasClass("up-qty")){
              cart = parseInt(n) + 1;
            }else if (n >1){
              cart = parseInt(n) - 1;
            }

            i.find(".quantity").val(cart);
            if (i.find(".total-price").length > 0) {
              mt._updatepricequickview()
            }      
          });
          
          if (window.show_multiple_currencies) {
            if(typeof Currency != 'undefined')
              Currency.convertAll(window.shop_currency, jQuery('#currencies .currency.selected').data('currency'), 'span.money', 'money_format')
              }
          mt._loadslideimagequickview(n, i);
          mt._addtocartquickview();
          //wishlist
          mt._quickviewwishlist();
          mt.translateBlock(".product-quickview");
          jQuery(".product-quickview").fadeIn(500);
          
          if (jQuery(".product-quickview .total-price").length > 0) {
            jQuery(".product-quickview input[name=quantity]").on("change", mt._updatepricequickview)
          }
        });
        return false
      });
      jQuery(".product-quickview .overlay, .quickview_overlay, .close-popup, .overlay").live("click", function() {
        $("#header-content").removeClass("show-quick")
        jQuery(".product-quickview").removeClass('active');
        $(".header-content-overlay").removeClass("show-quick").fadeOut();
        
        mt._closequickview();
        $(".ajax-success-cbox").hide();
        return false
      })
    },

    _quickshop: function() {
      jQuery(".quickshop a").click(function() {
//         console.log('lol');
        var n = jQuery(this).attr("id");

        Shopify.getProduct(n, function(n) {
          var cart = jQuery("#quickview-popup").html();
          jQuery(".quick-shop-content"+ n.id).html(cart);

          var i = jQuery(".quick-shop-content"+ n.id);

          i.find(".price").html(Shopify.formatMoney(n.price, window.money_format));
          i.find(".product-item").attr("id", "product-" + n.id);
          i.find(".variants").attr("id", "product-actions-" + n.id);
          i.find(".variants select").attr("id", "product-select-" + n.id);
          if (n.compare_at_price > n.price) {
            i.find(".compare-price").html(Shopify.formatMoney(n.compare_at_price_max, window.money_format)).show();
            i.find(".price").addClass("on-sale")
          } else {
            i.find(".compare-price").html("");
            i.find(".price").removeClass("on-sale")
          }
          if (!n.available) {
            i.find("select, input, .total-price, .dec, .inc, .variants label").remove();
            i.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass("disabled").attr("disabled", "disabled");
          } else {
            i.find(".total-price span").html(Shopify.formatMoney(n.price, window.money_format));
            if (window.use_color_swatch) {
              mt._createvariantquickviewwatch(n, i)
            } else {
              mt._createquickviewvariant(n, i)
            }
          }

          if (window.show_multiple_currencies) {
            if(typeof Currency != 'undefined')
              Currency.convertAll(window.shop_currency, jQuery('#currencies .currency.selected').data('currency'), 'span.money', 'money_format')
              }

          mt._addtocartquickview();
          mt.translateBlock(".quick-shop-content");
          jQuery(".quick-shop-content").fadeIn(500);
          if (jQuery(".quick-shop-content .total-price").length > 0) {
            jQuery(".quick-shop-content input[name=quantity]").on("change", mt._updatepricequickview)
          }
        });
        return false
      });
    },

    _updatepricequickview: function() {
      var mt = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      var n = jQuery(".product-quickview .price").text().match(mt);
      if (!n) {
        mt = /([0-9]+[.|,][0-9]+)/g;
        n = jQuery(".product-quickview .price").text().match(mt)
      }
      if (n) {
        var cart = n[0];
        var i = cart.replace(/[.|,]/g, "");
        var s = parseInt(jQuery(".product-quickview input[name=quantity]").val());
        var o = i * s;
        var u = Shopify.formatMoney(o, window.money_format);
        u = u.match(mt)[0];
        var a = new RegExp(r, "g");
        var f = jQuery(".product-quickview .price").html().replace(a, u);
        jQuery(".product-quickview .total-price span").html(f)
      }
    },
    _addtocartquickview: function() {
      if (jQuery(".product-quickview .add-to-cart-btn").length > 0) {
        jQuery(".product-quickview .add-to-cart-btn").click(function() {
          jQuery(".product-quickview").removeClass("first");
          var n = jQuery(".product-quickview select[name=id]").val();
          if (!n) {
            n = jQuery(".product-quickview input[name=id]").val()
          }
          var cart = jQuery(".product-quickview input[name=quantity]").val();
          if (!cart) {
            cart = 1
          }
          var i = jQuery(".product-quickview .product-title a").text();
          var s = jQuery(".product-quickview .quickview-featured-image img").attr("src");
          
          
          mt._ajaxaddtocart(n, cart, i, s);
          //mt._cartonafter();
          //mt._closequickview();
        })
      }
    },
    _cartonafter: function(){
      $(".quickview-overlay").show();
    },
//     _updateheadercart: function() {
//       Shopify.getCart(function(e) {
//         mt._headercartitem(e);
//         mt.free_shipping();
//       })
//     },
//     _headercartitem: function(n) {
//       $(".cart-count").text(n.item_count);
//       if( n.item_count > 0){
//         $(".itemsin").css("opacity","1");
//       }else{
//         $(".itemsin").css("opacity","0");
//       }
//     },


    convertToSlug: function(e) {
      return $.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
    },

    _updateheadercart: function(n, sale) {
      Shopify.getCart(function(e) {
        mt._headercartitem(e, sale);
        mt.free_shipping();
      })
    },
// ITG CODE START
    _headercartitem: function(n, sale) {
      var cart = '<li class="item" id="cart-item-{ID}" data-key="{varkey}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove Item" class="btn-remove"><i class="cs-font clever-icon-close"></i></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral"><span class="price_one">{PRICE2}</span><span class="qty-cart">Qty:  {QUANTITY}</span><span class="price">{PRICE}</span><div class="main_prop">{propeties}</div></div></div></li>';    
      
      if(n.item_count == 0){
        $(".cart-count").hide();
      }else{
        $(".cart-count").show();
      }
      
      $(".cart-count").html(n.item_count);
      $(".cart-count-2").html("("+n.item_count+")");

      $(".cartToggle .price-cart-mini").html(Shopify.formatMoney(n.total_price, window.money_format));
      $("#dropdown-cart .summary .price").html(Shopify.formatMoney(n.total_price, window.money_format));
      $("#dropdown-cart .cart-list").html("");
      
      
      if (n.item_count > 0) {
        for (var i = 0; i < n.items.length; i++) {  
          var properties = n.items[i].properties;
          var content_create = '';
          for (var key in properties) {
            if (key.indexOf('__') == -1) {
              var value = properties[key];
              console.log(value)
              if (value != ''){
                  content_create += '<div class="product-option"><dt>' + key + ':</dt><dd>' + value + '</dd></div>';
                 // content_create = 'Send this as a gift.'
                
              }
             }
          }
          
          var s = cart;
          s = s.replace(/\{ID\}/g, n.items[i].id);
          s = s.replace(/\{URL\}/g, n.items[i].url);
          //size variant off
          var $title = n.items[i].title;
          var item_key = n.items[i].key;
          
           if(n.items[i].title.includes(" - L")){
             $title = $title.replace(" - L","");
           }else if(n.items[i].title.includes(" - M")){
             $title = $title.replace(" - M","");
           }else if(n.items[i].title.includes(" - S")){
             $title = $title.replace(" - S","");
           }else if(n.items[i].title.includes(" - XS / S")){
             $title = $title.replace(" - XS / S","");
           }else if(n.items[i].title.includes(" - XS / XS")){
             $title = $title.replace(" - XS / XS","");
           };

          s = s.replace(/\{TITLE\}/g, mt.translateText($title));
          s = s.replace(/\{varkey\}/g, item_key);
          s = s.replace(/\{TITLE\}/g, n.items[i].title);
          s = s.replace(/\{QUANTITY\}/g, n.items[i].quantity);
          s = s.replace(/\{IMAGE\}/g, Shopify.resizeImage(n.items[i].image, "small"));
          s = s.replace(/\{SALE\}/g, Shopify.formatMoney(sale, window.money_format));
          s = s.replace(/\{PRICE2\}/g, Shopify.formatMoney(n.items[i].price, window.money_format));
          s = s.replace(/\{PRICE\}/g, Shopify.formatMoney(n.items[i].line_price, window.money_format));
          s = s.replace(/\{propeties\}/g, content_create);
          
          
          $("#dropdown-cart .cart-list").append(s);
          mt._overcart();

        }
        $("#dropdown-cart .btn-remove").click(function(n) {
          $( ".mini_cart_header .less-than-ten" ).empty();
          $(this).addClass('remove-cart');
          n.preventDefault();
          var cart = $(this).closest(".item").data("key");
          // var cart = $(this).parents(".item").attr("id");
          // cart = cart.match(/\d+/g);

          Shopify.removeItem(cart , function(e) {
            mt._headercartitem(e);

          })
          mt.free_shipping();
        });
        if (mt._checkcurrency()) {
          if(typeof Currency != 'undefined')
            Currency.convertAll(window.shop_currency, jQuery('#currencies .currency.selected').data('currency'), "#dropdown-cart span.money", "money_format")
            }

      }

      mt.free_shipping();
      mt._checkitemdropcart()
    },
// ITG CODE END
    free_shipping: function(n) {
      //console.log($(".total .price").text());
      var price= $(".total .price").text();
      str = price.replace('.00', '');
      str = str.replace(',', '');

      str = str.replace('USD', '');
      //console.log(str);
      cart_price = str.match(/\d+/g);

      price_pase = parseFloat(cart_price);
   
      //       console.log(window.calculte_free_shipping_number);
      //       console.log(window.calculte_free_shipping_number/100);
      //       console.log(cart_price/window.calculte_free_shipping_number*100)
      //       console.log(Math.floor(cart_price/window.calculte_free_shipping_number*100).toFixed(0));
      //		console.log(parseFloat(cart_price/window.calculte_free_shipping_number*100).toFixed(1));
      if (50 < parseFloat(price_pase/window.calculte_free_shipping_number*100).toFixed(1) < 99 ){
        jQuery('.progressbar').addClass('yellow');
        jQuery('.progressbar').removeClass('green');
      }
      if ( parseFloat(price_pase/window.calculte_free_shipping_number*100).toFixed(1) < 50 ){
        jQuery('.progressbar').removeClass('yellow');
        jQuery('.progressbar').removeClass('green');
      }
      if (parseFloat(price_pase/window.calculte_free_shipping_number*100).toFixed(1) > 99){
        jQuery('.progressbar').removeClass('yellow');
        jQuery('.progressbar').addClass('green');
      }else{

      }

      if(price_pase > window.calculte_free_shipping_number){
        $('.mini_cart_header .progressbar').addClass('full-process');
        if ( $('.mini_cart_header .less-than-ten').length > 0){
          $( ".mini_cart_header .less-than-ten" ).empty();

          $('.full-free-ship').show();
          $('.cart-congrats').hide();

          $('.mini_cart_header .less-than-ten').append("100%");
        }
      }else{

        $('.mini_cart_header .progressbar').removeClass('full-process');
        $('.full-free-ship').hide();
        $('.cart-congrats').show();
        $('.mini_cart_header .less-than-ten').append(Math.floor(price_pase/window.calculte_free_shipping_number*100).toFixed(0) + "%");
        $('.mini_cart_header .less-than-ten').css("width",Math.floor(price_pase/window.calculte_free_shipping_number*100).toFixed(0) + "%");
        if ( $('.mini_cart_header .less-than-ten').length > 0){


          $( ".mini_cart_header .less-than-ten" ).empty();
          $('.mini_cart_header .less-than-ten').append(Math.floor(price_pase/window.calculte_free_shipping_number*100).toFixed(0) + "%");
        }
      }

    },
    _checkcurrency: function() {
      if(typeof Currency != 'undefined')
        return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency
        },

    //endcart

    _quickviewthumbslide: function(e) {
      if (e) {
        e.owlCarousel({
          loop:true,
          margin:1,
          responsiveClass:true,
          navText: ['<i class="cs-font clever-icon-prev"></i>','<i class="cs-font clever-icon-next"></i>'],
          responsive:{
            0:{
              items:3,
              nav:true
            },
            600:{
              items:3,
              nav:true,
              loop:false
            },
            1000:{
              items:3,
              nav:true,
              loop:false
            }
          }
        }).css("visibility", "visible")
      }
    },
    convertToSlug: function(e) {
      return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
    },
    _createvariantquickviewwatch: function(mt, n) {
      // console.log(mt.variants)
      if (mt.variants.length > 0) {
        for (var cart = 0; cart < mt.variants.length; cart++) {
          var i = mt.variants[cart];
          var s = '<option value="' + i.id + '">' + i.title + "</option>";
          n.find("form.variants select").append(s)
        }
        new Shopify.OptionSelectors("product-select-" + mt.id, {
          product: mt,
          onVariantSelected: selectCallbackQuickview
        });
        
        var o = window.file_url.substring(0, window.file_url.lastIndexOf("?"));
        var u = window.asset_url.substring(0, window.asset_url.lastIndexOf("?"));
        var a = "";
        if(mt.variants.length == 1 ){
          n.find(".prices").addClass("fullW")
        }else{
        for (var cart = 0; cart < mt.options.length; cart++) {
          var f = false;
          if (/Color|Colour/i.test(mt.options[cart].name)) {
            f = true
          }
          a += '<div class="swatch clearfix swatch-' + cart + ' ' + (f ? "color" : "") + '" data-option-index="' + cart + '">';
          a += '<p class="pdshop_title">' + mt.options[cart].name + "</p>";

          // console.log(n.find(".prices .price .money").text())
          
          var l = new Array;
          for (var c = 0; c < mt.variants.length; c++) {
            var i = mt.variants[c];
            var h = i.options[cart];
            var p = this.convertToSlug(h);
            var d = "swatch-" + cart + "-" + p;
            var r = mt.variants[c].price;
            
            if (l.indexOf(h) < 0) {

              a += '<div data-price="'+ r + '"data-value="' + h + '"id="'+i.id+'"'+'class="swatch-element ' + (f ? "color" : "") + p + (i.available ? " available active" : " soldout ") + '">';
              a += '<input id="' + d + '" type="radio" name="option-' + cart + '" value="' + h + '" ' + (c == 0 ? " checked " : "") + (i.available ? "" : " disabled") + " />";
              if (f) {
                if(window.swatch_style1){
                  a += '<label for="' + d + '" style= "background-color: ' + p + '";></label>'
                }
                if(window.swatch_style2){
                  a += '<label for="' + d + '" style= " background-image: url(' + o + p + '.png)"></label>'
                }
                if(window.swatch_style3){
                  a += '<label for="' + d + '" style= "background-image: url(' + mt.variants[c].featured_image.src + ')"></label>'
                }
              } else {
                // a += '<span>' + h + '</span>'
                 a += '<lable for="'+ d +'" class="none"><span>'+ h +'</span></label>'
              }
              a += "</div>";
              if (i.available) {
                jQuery('.product-quickview .swatch[data-option-index="' + cart + '"] .' + p).removeClass("soldout").addClass("available").find(":radio").removeAttr("disabled")
              }
             
              l.push(h)
            }
          }
          a += "</div>"
        }
        }
        
        n.find("form.variants select").after(a);
        n.find(".swatch .swatch-element.available").click(function(){
          var mt = jQuery(this).closest(".swatch").attr("data-option-index");
          var n = jQuery(this).attr("id");
          var p = jQuery(this).attr("data-price");

          jQuery(".swatch .swatch-element").removeClass("active");
          jQuery(this).addClass("active");
          
          jQuery(this).closest("form").find(".single-option-selector.quickOp").eq(mt).val(n).trigger("change");
          jQuery(this).closest("form").find(".price").html(Shopify.formatMoney(p, window.money_format));
          
        });
        n.find(".swatch :radio").change(function() {
          var mt = jQuery(this).closest(".swatch").attr("data-option-index");
          var n = jQuery(this).val();
          jQuery(this).closest("form").find(".single-option-selector").eq(mt).val(n).trigger("change")
        });
        if (mt.available) {
          Shopify.optionsMap = {};
          Shopify.linkOptionSelectors(mt)
        }
      } else {
        n.find("form.variants select").remove();
        var v = '<input type="hidden" name="id" value="' + mt.variants[0].id + '">';

        n.find("form.variants").append(v)
      }
    },
    _createquickviewvariant: function(mt, n) {
      
      if (mt.variants.length > 1) {
        // console.log(mt)
        jQuery(".selector-wrapper").show();
        for (var cart = 0; cart < mt.variants.length; cart++) {
          var i = mt.variants[cart];
          var s = '<option value="' + i.id + '">' + i.title + "</option>";
          n.find("form.variants > select").append(s)
        }
        new Shopify.OptionSelectors("product-select-" + mt.id, {
          product: mt,
          onVariantSelected: selectCallbackQuickview
        });
        jQuery(".product-quickview .single-option-selector").selectize();
        jQuery(".product-quickview .selectize-input input").attr("disabled", "disabled");
        if (mt.options.length == 1) {
          jQuery(".selector-wrapper:eq(0)").prepend("<label>" + mt.options[0].name + "</label>")
        }
        n.find("form.variants .selector-wrapper label").each(function(n, cart) {
          jQuery(this).html(mt.options[n].name)
        })
      } else {
        n.find("form.variants > select").remove();
        var o = '<input type="hidden" name="id" value="' + mt.variants[0].id + '">';
        n.find("form.variants").append(o)
      }
    },
    _closequickview: function() {
      jQuery(".product-quickview").fadeOut(500);
    },
    translateText: function(str) {
      // console.log("title "+str)
      let Keywords = ['BASIC', ' ICONIC', ' SOLID', ' COLOR', ' HERRINGBONE', ' HOUNDSTOOTH', ' DIPTYCH', ' BURNED', ' DUPLE', ' DUO', ' CHIFFON', ' CHECK', 'E-GIFT'];
      Keywords.forEach(function (keyword) {
          if (str.indexOf(keyword) != -1 && str.indexOf('<br>') == -1) {
              str = str.replace(keyword, `<br>${keyword} `);
          }
      });
      if (!window.enable_multilang || str.indexOf("|") < 0)
        return str;

      if (window.enable_multilang) {
        var textArr = str.split("|");
        if (translator.isLang2())
          return textArr[1];
        return textArr[0];
      }          
    },
    translateBlock: function(blockSelector) {
      if (window.enable_multilang && translator.isLang2()) {
        translator.doTranslate(blockSelector);
      }
    }

  }

  $(document).ready(function(){
    var $qty,
        $select,
        quantity,
        originQty;
    
    $(".cart-list tbody tr").each(function(){
      $qty = $(this).find(".custom-qty .qtyinput").val() -1;
      $(this).find(".custom-qty .qty-selector li").eq($qty).addClass("active");
      
    })
    
    
    $(".custom-qty .qtyinput").click(function(){
      $(".qty-overlay").toggleClass("active");
      $(this).parents(".custom-qty").find(".qty-selector").toggleClass("active");
    })
    
    $(".qty-overlay").click(function(){
      $('.qty-selector ul').scrollTop(0);
      $(".qty-selector").removeClass("active");
      $(this).removeClass("active");
    })
    
    $(".custom-qty .qty-selector li").click(function(){
      quantity = $(this).find("input").val();
      originQty =  $(this).parents(".custom-qty").find(".qtyinput").val();

      $(this).parents(".qty-selector").removeClass("active");
      $(".qty-overlay").removeClass("active");
      if(quantity != originQty){
        $(this).parents(".custom-qty").find(".qtyinput").val(quantity);
        $("#update-cart").trigger("click");
      }
    });
    
    $('.up-qty').click(function(){
      $qty = $(this).parents(".custom-qty").find('.qtyinput');
      quantity =$qty.val();
      $qty.val(parseInt(quantity) + 1);
    });
    $('.down-qty').click(function(){
      $qty = $(this).parents(".custom-qty").find('.qtyinput');
      quantity =$qty.val();
      if(quantity > 1)
        $qty.val(parseInt(quantity) - 1);
    });
  });


})(jQuery);

// ITG Code Start
 
 $(function(){
    var dtToday = new Date();
    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();
    if(month < 10)
        month = '0' + month.toString();
    if(day < 10)
        day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('.field__input[type="date"]').attr('min', maxDate);
});

// ITG Code end